// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" className=\"feather feather-chevron-down\"><path stroke=\"%23fff\" stroke-width=\"1\" d=\"M6 9l6 6 6-6\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* *-----------------------------------------------------------------------------------
    CSS INDEX
    ===================
    1. Default
    2. Sidebar
    3. Header
    4. Menu Button
    5. Footer
    6. Main Content
    7. Page Heading
    8. Avatar
    9. Card
    10. Table
    11. Forms
    12. Button
    13. Switch Button 1
    14. Modal
    15. Login Screen
    16. Pagination
    17. Page Not Found
    18. Loader
    19. Sweet Alert
    20. React Switch
    21. Darkmode
/*--------------------------------------------------------------
    1. Default
--------------------------------------------------------------*/
* {
    outline-color: transparent;
    outline-style: none;
}

:root {
    --white: #FFFFFF;
    --light: #E6ECFF;
    --light2: #E5F0FF;
    --dark: #24272C;
    --gray: #6C737D;
    --primary: #456DFF;
    --success: #34A853;
    --danger: #EA4335;
    --warning: #FFBF1C;
    --info: #4285F4;
    --purple: #8652ff;
    --border: #CED8E7;
    --border2: #CEE5FC;
    --font-white: #FFFFFF;
    --box-shadow: 0 0 6px -4px #00000014, 0 0 16px 0 #0000000d, 0 0 28px 8px #0000000d;
}

[data-theme="waitover-darks"] {
    --white: #201e26;
    --light: #141218;
    --light2: #141218;
    --dark: #b2b2b2;
    --gray: #b2b2b2;
    --primary: #456DFF;
    --success: #44CF94;
    --danger: #EA4335;
    --warning: #FFBF1C;
    --info: #4285F4;
    --purple: #8652ff;
    --border: #2e2d32;
    --border2: #2e2d32;
    --font-white: #FFFFFF;
    --box-shadow: 0 3px 6px -4px #0000006b, 0 0 16px 0 #0000002b, 0 0 28px 8px #0000004a !important;
}
html.light {
    --white: #FFFFFF;
    --light: #E6ECFF;
    --light2: #E5F0FF;
    --dark: #24272C;
    --gray: #6C737D;
    --primary: #456DFF;
    --success: #34A853;
    --danger: #EA4335;
    --warning: #FFBF1C;
    --info: #4285F4;
    --purple: #8652ff;
    --border: #EDEDED;
    --border2: #CEE5FC;
    --font-white: #FFFFFF;
}
html.dark {
    --white: #201e26;
    --light: #141218;
    --light2: #141218;
    --dark: #b2b2b2;
    --gray: #b2b2b2;
    --primary: #456DFF;
    --success: #44CF94;
    --danger: #EA4335;
    --warning: #FFBF1C;
    --info: #4285F4;
    --purple: #8652ff;
    --border: #2e2d32;
    --border2: #2e2d32;
    --font-white: #FFFFFF;
}
body {
    font-family: 'Maven Pro', sans-serif;
    color: var(--dark);
    font-size: 15px;
    background-color: var(--light2);
    overflow-x: hidden;
    scroll-behavior: smooth;
}
::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important;
}
::-webkit-scrollbar-track {
    background-color: transparent !important;
}
::-webkit-scrollbar-thumb {
    background: var(--gray);
    border-radius: .325rem;
}
::selection {
    color: var(--font-white);
    background-color: var(--primary);
}
::-moz-selection {
    color: var(--font-white);
    background-color: var(--primary);
}
a {
    color: var(--dark);
    text-decoration: none;
}
a:hover, a:focus{
    text-decoration: none;
}
a:hover {
    color: var(--primary);
}
a:-webkit-any-link:focus-visible {
    outline-offset: 0;
}
a:-webkit-any-link:focus-visible {
    outline-offset: unset;
}
select {
    background-color: var(--light) !important;
}
.dropdown-item{
    font-weight: 500;
    color: var(--dark);
}
.dropdown-item:focus, .dropdown-item:hover {
    color: var(--dark);
    background-color: var(--light);
}
button:focus,
.btn-close:focus,
.btn:focus-visible,
.btn:focus {
    outline: 0;
    box-shadow: unset;
}
:focus-visible {
    outline: unset;
}

:focus-visible {
    outline: 0;
}
:-webkit-direct-focus {
    outline-color: unset;
    outline-style: unset;
    outline-width: 0 !important;
}
:focus {
    outline-color: unset;
    outline-style: unset;
    outline-width: 0;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
    -webkit-text-fill-color: var(--dark);
    background-color: var(--light);
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s;
    -webkit-box-shadow: unset !important;
}
.form-control::-webkit-input-placeholder,
input[type=text]::-webkit-input-placeholder,
input[type=password]::-webkit-input-placeholder,
input[type=datetime]::-webkit-input-placeholder,
input[type=datetime-local]::-webkit-input-placeholder,
input[type=date]::-webkit-input-placeholder,
input[type=month]::-webkit-input-placeholder,
input[type=time]::-webkit-input-placeholder,
input[type=week]::-webkit-input-placeholder,
input[type=number]::-webkit-input-placeholder,
input[type=email]::-webkit-input-placeholder,
input[type=url]::-webkit-input-placeholder,
input[type=search]::-webkit-input-placeholder,
input[type=tel]::-webkit-input-placeholder,
input[type=color]::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
    color: #6C737D
}
html.dark .form-control::-webkit-input-placeholder,
html.dark input[type=text]::-webkit-input-placeholder,
html.dark input[type=password]::-webkit-input-placeholder,
html.dark input[type=datetime]::-webkit-input-placeholder,
html.dark input[type=datetime-local]::-webkit-input-placeholder,
html.dark input[type=date]::-webkit-input-placeholder,
html.dark input[type=month]::-webkit-input-placeholder,
html.dark input[type=time]::-webkit-input-placeholder,
html.dark input[type=week]::-webkit-input-placeholder,
html.dark input[type=number]::-webkit-input-placeholder,
html.dark input[type=email]::-webkit-input-placeholder,
html.dark input[type=url]::-webkit-input-placeholder,
html.dark input[type=search]::-webkit-input-placeholder,
html.dark input[type=tel]::-webkit-input-placeholder,
html.dark input[type=color]::-webkit-input-placeholder,
html.dark textarea::-webkit-input-placeholder {
     color: #444444
}
.text-primary{
    color: var(--primary) !important;
}
.border{
    border-color: var(--border) !important;
}
.border-bottom{
    border-color: var(--border) !important;
}
.border-start{
    border-color: var(--border) !important;
}
hr{
    border-color: var(--border) !important;
    opacity: 1;
}
/*--------------------------------------------------------------
    2. Sidebar
--------------------------------------------------------------*/
.sidebar-wrapper {
    width: 250px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    background-color: var(--white);
    bottom: 0;
    transition: width 0.3s ease-out, left 0.5s ease-out;
}
/* SideBar Header*/
.sidebar-wrapper .sidebar-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 75px;
    border-right: 1px solid var(--border);
}
.sidebar-wrapper .sidebar-header img {
    display: block;
    max-width: 100%;
    height: 44px;
    margin: 0 auto;
}
/* SideBar Menu*/
.sidebar-menu {
    position: relative;
    width: 250px;
    height: calc(100vh - 75px);
    background-color: var(--white);
    border-top: 1px solid var(--border);
    border-right: 1px solid var(--border);
    overflow-y: auto;
    transition: width 0.3s ease-out;
}

.sidebar-wrapper .menu {
    margin-top: 1rem;
    padding: 0;
    font-weight: 600;
}

.sidebar-wrapper .menu .sidebar-link {
    position: relative;
    display: flex;
    align-items: center;
    padding: 1rem;
    margin: 0 1rem;
    font-size: 15px;
    font-weight: 500;
    border-radius: 0.5rem;
    transition: 0.3s;
    text-decoration: none;
    color: var(--gray);
}

.sidebar-wrapper .menu .sidebar-link.active i,
.sidebar-wrapper .menu .sidebar-link.active>span {
    color: var(--primary);
}

.sidebar-wrapper .menu .sidebar-link.active{
    background-color: rgb(69 109 255 / 7%);
}
.sidebar-wrapper .menu .sidebar-link i {
    font-size: 1.25rem;
    color: var(--gray);
}

.sidebar-wrapper .menu .sidebar-link span {
    margin-left: .7rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 15ch;
}

.sidebar-wrapper .menu .sidebar-item:hover a,
.sidebar-wrapper .menu .sidebar-item:hover a i,
.sidebar-wrapper .menu .sidebar-link:hover,
.sidebar-wrapper .menu .sidebar-link:hover i {
    color: var(--primary);
}

.sidebar-wrapper .menu .sidebar-item {
    list-style: none;
    position: relative;
}

.sidebar-wrapper .menu .sidebar-item.has-sub .sidebar-link {
    cursor: pointer;
}

.sidebar-wrapper .menu .sidebar-item.has-sub .sidebar-link:after {
    content: "\\ea4a";
    font-family: boxicons !important;
    position: absolute;
    color: var(--gray);
    right: 15px;
    top: 14px;
    display: block;
    font-size: 20px;
}
.sidebar-wrapper .menu .sidebar-item.active .sidebar-link:before {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 30px;
    background-color: var(--primary);
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}
.sidebar-wrapper .menu .sidebar-item .sidebar-link.active span,
.sidebar-wrapper .menu .sidebar-item.has-sub.active .sidebar-link:after,
.sidebar-wrapper .menu .sidebar-item.has-sub:hover .sidebar-link:after {
    color: var(--primary);
}

.sidebar-wrapper .menu .sidebar-item .sidebar-link.active i,
.sidebar-wrapper .menu .sidebar-item .sidebar-link.active svg {
    fill: var(--primary);
    color: var(--primary);
}

.sidebar-wrapper .menu .sidebar-item.active .sidebar-link.has-sub:after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.sidebar-wrapper .menu .submenu {
    list-style: none;
    display: none;
    transition: max-height 2s cubic-bezier(0, 0.55, 0.45, 1);
    overflow: hidden;
}

.sidebar-wrapper .menu .submenu.active {
    max-height: 999px;
    display: block;
}

.sidebar-wrapper .menu .submenu .submenu-item.active {
    position: relative;
}

.sidebar-wrapper .menu .submenu .submenu-item a.active {
    color: var(--primary);
}

.sidebar-wrapper .menu .submenu .submenu-item.active>a {
    color: var(--primary);
}

.sidebar-wrapper .menu .submenu .submenu-item a {
    padding: 0.7rem 1.4rem;
    padding-left: 2.1rem;
    display: block;
    color: var(--gray);
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.5px;
    transition: all 0.3s;
}

.sidebar-wrapper .menu .submenu .submenu-item a:hover {
    color: var(--primary);
}
.layout-wrapper .toggler {
    display: none;
}
.dark .layout-wrapper .sidebar-logo .logo{
    display: none;
}
.dark .layout-wrapper .sidebar-logo .logodark{
    display: block !important;
}
.layout-wrapper .sidebar-logo .logo-mini{
    display: none;
}
.layout-wrapper.collapsed .menu .sidebar-item.has-sub .sidebar-link:after{
    opacity: 0 
}
.layout-wrapper.collapsed .sidebar-menu:hover .sidebar-item.has-sub .sidebar-link:after{
    opacity: unset;
}
@media screen and (min-width: 1199px) {
    .layout-wrapper.collapsed .sidebar-logo .logo{
        display: none;
    }
    .layout-wrapper.collapsed .sidebar-logo .logo-mini{
        display: block;
    }
    .layout-wrapper.collapsed .sidebar-logo .logodark{
        display: none !important;
    }
    .layout-wrapper.collapsed .sidebar-menu:hover{
        width: 250px;
    }
    .layout-wrapper .toggler {
        display: block;
        position: fixed;
        left: 265px;
        top: 23.5px;
        transition: left 0.3s ease-out;
        z-index: 99;
    }
    .layout-wrapper.collapsed .sidebar-wrapper,
    .layout-wrapper.collapsed .sidebar-menu{
        width: 85px;
    }
    .layout-wrapper.collapsed header.sidebar-header{
        left: 85px;
        width: calc(100% - 85px);
    }
    .layout-wrapper.collapsed .toggler{
        left: 100px;
    }
    .layout-wrapper.collapsed #main {
        margin-left: 85px;
    }
}
@media screen and (max-width: 1199px) {
    .sidebar-wrapper {
        position: fixed;
        left: -250px;
    }
    .sidebar-wrapper .sidebar-toggler.x {
        display: block;
    }
    .sidebar-wrapper.active {
        left: 0 !important;
    }
}
/*--------------------------------------------------------------
    3. Header
--------------------------------------------------------------*/
header.sidebar-header {
    background-color: var(--white);
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    left: 250px;
    width: calc(100% - 250px);
    height: 75px;
    padding: 0 1.5rem;
    transition: left 0.3s ease-out;
    z-index: 9;
}
header.sidebar-header.full-header{
    width: 100%;
    left: 0;
}
.sidebar-header .header-left-menu .logo,
.sidebar-header .sidebar-logo .logo,
.sidebar-header .header-left-menu .logodark,
.sidebar-header .sidebar-logo .logodark{
    width: 200px;
    height: auto;
}
.sidebar-header .header-left-menu .logo-mini,
.sidebar-header .header-right-menu .logo-mini,
.sidebar-header .sidebar-logo .logo-mini{
    height: 44px;
    width: auto;
}
html.dark .sidebar-header .header-left-menu .logo path:first-child,
html.dark .sidebar-header .sidebar-logo .logo path:first-child{
    fill: var(--font-white);
}
html.dark .sidebar-header .header-left-menu .logo-mini path:last-child,
html.dark .sidebar-header .header-right-menu .logo-mini path:last-child,
html.dark .sidebar-header .sidebar-logo .logo-mini path:last-child{
    fill: var(--font-white);
}
header .header-right-menu{
    display: flex;
    align-items: center;
}
header .header-right-menu .dropdown .dropdown-toggle {
    display: block;
    border: none;
    padding: 0.5rem;
    background-color: var(--light);
    border-radius: 0.625rem;
    margin: 0;
    width: 100%;
    box-shadow: none;
}
header .header-right-menu .user-menu img{
    width: 44px;
    height: 44px;
    max-width: 44px;
    min-height: 44px;
    border: 1px solid var(--border);
    border-radius: .625rem;
}
header .header-right-menu .dropdown .dropdown-toggle::after {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 12px;
    border-top: 0.3em solid var(--dark);
}

header .header-right-menu .dropdown-menu.show {
    display: block;
    margin: 1rem .625rem 1rem -.625rem!important;
    min-width: 218px !important;
    border-radius: 0.625rem;
    background-color: var(--white);
    box-shadow: 0 0 20px 3px #00000014;
    border: none;
}
header .header-right-menu .dropdown-item.active, header .header-right-menu .dropdown-item:active {
    color: var(--font-white);
    text-decoration: none;
    background-color: var(--primary);
}
header .header-right-menu .dropdown-divider {
    border-top-color: var(--border);
}

header .header-right-menu .dropdown .user-menu {
    display: flex;
    align-items: center;
    padding-right: 24px;
}

header .header-right-menu .dropdown .user-menu .user-name {
    text-align: left;
}

header .header-right-menu .dropdown .user-menu .user-name h6 {
    color: var(--dark);
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 15ch;
}

header .header-right-menu .dropdown .user-menu .user-name p {
    color: var(--gray);
    margin-bottom: 0;
    font-size: 14px;
}
@media (max-width: 1199.98px) {
    header.sidebar-header {
        left: 0;
        width: 100%;
    }
    header .header-right-menu .burger-btn{
        margin-left: .25rem;
    }
}
@media (max-width: 767.98px){
    .full-header .header-right-menu .btn {
        --bs-btn-padding-y: 0.25rem;
        --bs-btn-padding-x: 0.5rem;
        --bs-btn-font-size: 0.875rem;
        --bs-btn-border-radius: 0.25rem;
    }
}
@media (max-width: 575px) {
    header.sidebar-header{
        padding: 0 1rem;
    }
    header .header-right-menu .user-menu img {
        width: 36px;
        height: 36px;
        max-width: 36px;
        min-height: 36px;
        border: 1px solid var(--border);
        border-radius: 0.375rem;
    }
}
@media (max-width: 450px) {
    header .header-right-menu .dropdown .user-menu .user-name h6 {
        max-width: 7ch;
    }
}
@media (max-width: 350px) {
    header .header-right-menu .dropdown .user-menu .user-name{
        display: none;
    }
}
/*--------------------------------------------------------------
    4. Menu Button
--------------------------------------------------------------*/
.burger-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--white);
    color: var(--dark) !important;
    border: none;
    width: 35px;
    height: 35px;
    font-size: 22px;
    border-radius: .625rem;
}
.burger-btn.btn{
    background-color: var(--white) !important;
    color: var(--dark) !important; 
}
.burger-btn.btn i {
    color: var(--dark) !important;
}
/*--------------------------------------------------------------
    5. Footer
--------------------------------------------------------------*/
.page-footer {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 1rem;
    width: 100%;
    height: auto;
    background-color: var(--white);
    position: fixed;
    bottom: 0 !important;
    right: 0 !important;
}
.page-footer i {
    font-size: 18px;
    line-height: 24px;
    margin: 0 3px;
}
.page-footer a{
    color: var(--primary);
    font-weight: 600;
    margin:0 3px;
}
/*--------------------------------------------------------------
    6. Main Content
--------------------------------------------------------------*/
#main {
    margin-left: 250px;
    padding: 105px 30px 30px;
    transition: margin-left 0.3s ease-out;
}
#main.full-page-content {
    margin-left: 0;
}
.page-content .card.radiustop-0{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
@media screen and (max-width: 1199px) {
    #main {
        margin-left: 0;
        padding: 91px 16px 16px 16px;
    }
}
/*--------------------------------------------------------------
    7. Page Heading
--------------------------------------------------------------*/
.page-heading {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    height: auto;
    background-color: var(--white);
    border-top-left-radius: 0.625rem;
    border-top-right-radius: 0.625rem;
    border-bottom: 1px solid var(--border);
}

.page-heading h3 {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: 700;
    color: var(--dark);
    padding-left: 1rem;
    margin-bottom: 0;
}
.page-heading h3::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 20px;
    background-color: var(--primary);
}
.page-heading h3 .btn-icon i{
    font-size: 1.75rem !important;
    color: var(--dark);
}
.page-heading.backbtn h3{
    padding-left: 0;
}
.page-heading.backbtn h3::before{
    content: unset;
}
.page-heading h3 span{
    color: var(--primary);
    margin-left: .25rem;
}
.page-title-headings {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
}

.page-title-headings h3 {
    margin-bottom: 0;
    margin-right: 1rem;
}
.page-heading-right{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}
.page-heading .breadcrumb {
    margin: 0;
}
.page-heading .breadcrumb .breadcrumb-item a {
    display: flex;
    align-items: center;
}
.page-heading .breadcrumb .breadcrumb-item.active {
    color: var(--primary);
}
.page-heading .page-heading-btn-group{
    display: flex;
    align-items: center;
    border: 1px solid var(--primary);
    border-radius: 50px;
    overflow: hidden;
}
.page-heading .page-heading-btn-group a{
    font-weight: 500;
    padding: 0.547rem 1rem;
    font-size: 15px;
    min-width: 110px;
    text-align: center;
}
.page-heading .page-heading-btn-group a.active{
    background-color: var(--primary);
    color: var(--font-white);
}
.custom-btn-add i{
    display: none;
}
@media (max-width: 768.98px) {
    .page-heading {
        padding: 1rem;
    }
    .custom-btn-add i{
        display: block;
        font-size: 20px;
    }
    .custom-btn-add span{
        display: none;
    }
}

@media (max-width: 575.98px) {
    .page-heading h3 {
        font-size: 22px;
    }
}
/*--------------------------------------------------------------
    8. Avatar
--------------------------------------------------------------*/
.avatar {
    display: inline-flex;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
    position: relative;
}
.avatar .avatar-content {
    width: 32px;
    height: 32px;
    color: var(--font-white);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.875rem;
}
.avatar .avatar-content i,
.avatar .avatar-content svg {
    color: var(--font-white);
    font-size: 1rem;
    height: 1rem;
}
.avatar img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
}
.avatar .avatar-status {
    width: 0.7rem;
    height: 0.7rem;
    position: absolute;
    border-radius: 50%;
    border: 1px solid var(--border);
    bottom: 0;
    right: 0;
}
.avatar.avatar-sm .avatar-content,
.avatar.avatar-sm img {
    width: 24px;
    height: 24px;
    font-size: 0.8rem;
}
.avatar.avatar-md .avatar-content,
.avatar.avatar-md img {
    width: 32px;
    height: 32px;
    font-size: 0.8rem;
}
.avatar.avatar-lg .avatar-content,
.avatar.avatar-lg img {
    width: 48px;
    height: 48px;
    font-size: 1.2rem;
}
.avatar.avatar-xl .avatar-content,
.avatar.avatar-xl img {
    width: 60px;
    height: 60px;
    font-size: 1.4rem;
}
/*--------------------------------------------------------------
    9. Card
--------------------------------------------------------------*/
.card {
    border: none;
    border-radius: .625rem;
    background-color: var(--white);
}

.card-header {
    border-bottom: none;
    background-color: var(--white);
    border-top-left-radius: .625rem !important;
    border-top-right-radius: .625rem !important;
    padding: 1.25rem;
}
.card-body {
    padding: 1.25rem;
}
.card-body .row:last-child {
    border-bottom: unset !important;
}
.card-image {
    margin-bottom: .5rem;
    overflow: hidden;
    padding-top: 50.2%;
    position: relative;
    border-radius: .525rem;
}
.card-image img {
    border-radius: .652rem;
    display: block;
    height: 100%;
    left: 0;
    object-position: center center;
    position: absolute;
    top: 0;
    width: 100%;
    margin-bottom: 0.5rem;
}
.card-footer {
    padding: 1.25rem;
    background-color: var(--white);
    border-top-color:var(--border);
    border-radius:  0 0 .625rem .625rem !important;
}
@media (max-width: 400px) {
    .card-header, .card-body, .card-footer{
        padding: 1rem;
    }
}
/*--------------------------------------------------------------
    10. Table
--------------------------------------------------------------*/
tbody,
td,
tfoot,
th,
thead,
tr {
    vertical-align: middle;
    color: var(--dark);
}
.table-bg-primary.table thead th{
    background-color: var(--primary) !important;
    color: var(--font-white);
}
thead th{
    padding: .75rem .5rem !important;
    background-color: var(--light) !important;
}
tbody td {
    color: var(--gray);
    font-weight: 500;
}
.table-responsive {
    box-shadow: 0 0 0 1px var(--border2);
    border-radius: .625rem;
    background-color: var(--white);
}

.table-responsive table {
    margin-bottom: 0;
}

.table-responsive .table> :not(caption)>*>* {
    padding: .5rem;
}

.table-responsive .table-bordered> :not(caption)>* {
    border-width: 0;
}

.table-responsive .table> :not(:last-child)> :last-child>* {
    border-bottom-color: var(--border2);
}

.table-responsive .table th,
.table-responsive .table td {
    border: 1px solid var(--border2);
}

.table-responsive .table th:first-child,
.table-responsive .table td:first-child {
    border-left: none;
}

.table-responsive .table th:last-child,
.table-responsive .table td:last-child {
    border-right: none;
}

.table-responsive .table tr:first-child th {
    border-top: none;
}

.table-responsive .table tr:last-child td {
    border-bottom: none;
}
.modal-img img{
    width: 40px;
    height: 40px;
    border-radius: .625rem;
}
.table-sort-filter {
    display: flex;
    align-items: center;
}
.table-sort-filter .table-sort {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-left: .5rem;
}
.table-sort-filter .table-sort i {
    font-size: 10px;
    color: var(--dark);
    line-height: .8;
    cursor: pointer;
}
.table-sort-filter .table-sort i.active{
    color: var(--primary);
}
.table-striped > tbody > tr:nth-of-type(odd) > * {
    --bs-table-accent-bg: var(--white);
    color: var(--gray);
}
.table-striped > tbody > tr:nth-of-type(even) > * {
    --bs-table-accent-bg: var(--light);
    color: var(--gray);
}
/*--------------------------------------------------------------
    11. Forms
--------------------------------------------------------------*/
.form-label {
    font-size: 14.5px;
    color: var(--gray);
    font-weight: 500;
    margin-bottom: 0;
}
label.form-label .rerq {
    color: var(--danger);
    margin-left: 0.1rem;
}
label.error {
    display: none;
    font-size: .875em;
    color: var(--danger);
    background-color: #ea433512;
    border-radius: .525rem;
    padding: 0 .5rem;
    margin-bottom: .5rem;
}
.invalid-feedback strong {
    font-size: .875em;
    color: var(--danger);
    background-color: #ea433512;
    border-radius: .525rem;
    padding: .2rem .5rem;
    margin-bottom: .5rem;
    font-weight: 500 !important;
}
.form-control-lg {
    min-height: calc(1.7em + 1rem + 2px) !important;
    padding: .5rem 1rem;
    font-size: 1.25rem;
    border-radius: .625rem;
}
.form-control-sm {
    min-height: calc(1.858em + 0.5rem + 2px) !important;
    border-radius: .325rem;
}
.form-control,
.form-select,
.rs-picker-default .rs-picker-toggle {
    padding: 0.375rem 0.75rem;
    min-height: 40px;
    border-radius: .625rem;
    color: var(--dark);
    font-size: 15px;
    font-weight: 500;
    border-color: var(--border);
    background-color: var(--white) !important;
}
.form-control:disabled{
    background-color: #E5F0FF !important;
    border-color: #CED8E7 !important;
}
.dark .form-control:disabled{
    border-color: var(--border) !important;
}
.dark .form-control,
.dark .form-select,
.dark .rs-picker-default .rs-picker-toggle{
    background-color: var(--light) !important;
}
.rs-picker.rs-picker-select.was-invalid .rs-picker-toggle{
    border-color: var(--danger) !important;
}
.input-group-text{
    border: none;
    background-color: var(--light);
    border-radius: .625rem;
}
.rs-picker-default .rs-picker-toggle.rs-btn {
    padding-top: 10px;
    padding-bottom: 10px;
}
.rs-picker-default .rs-picker-toggle.rs-btn .rs-picker-toggle-caret{
    top: 10px;
}

.rs-picker-default:not(.rs-picker-disabled) .rs-btn:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-btn:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-btn-active, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle-active,
.rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle-active,
.rs-picker-default:not(.rs-picker-disabled) .rs-btn:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-btn:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-btn-active, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle-active{
    border-color: #456dff80;
}
.rs-picker-toggle-active, .rs-picker.rs-picker-focused{
    box-shadow: unset;
}
.rs-picker-has-value .rs-btn .rs-picker-toggle-value, .rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value{
    color: var(--dark);
}
.rs-picker-menu{
    background-color: var(--white);
    border-radius: .625rem;
    z-index: 1060;
    padding: .5rem !important;
}
.rs-picker-select-menu-item{
    color: var(--dark);
    border-radius: .5rem;
    font-weight: 500;
    line-height: 1.2;
}
.rs-picker-select-menu-items{
    margin-bottom: 0;
}
.rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input{
    color: var(--dark);
    background-color: var(--light);
    border-color: var(--border);
    border-radius: .625rem;
    font-size: 15px;
}
.rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input:focus, .rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input:hover:not(:disabled),
.rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input:focus, .rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input:hover:not(:disabled){
    border-color: #456dff80;
}
.rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input:focus{
    outline: unset;
}
.rs-picker-select-menu-item:hover, .rs-picker-select-menu-item:focus, .rs-picker-select-menu-item.rs-picker-select-menu-item-focus{
    background-color: rgb(69 109 255 / 7%);
    color: var(--primary);
}
.rs-picker-select-menu-items .rs-picker-menu-group:not(:first-child) {
    border-top: 1px solid var(--border);
    border-top: 1px solid var(--border);
}
.rs-picker-select-menu-items .rs-picker-menu-group-title{
    color: var(--dark);
    font-weight: 600;
}
.form-select {
    padding: 0.375rem 2rem 0.375rem 0.75rem;
}
.form-control:focus,
.form-select:focus {
    border-color: #456dff80;
    outline: 0;
    box-shadow: unset;
    color: var(--dark);
    background-color: var(--white);
}
html.dark .form-control:disabled{
    background-color: #ffffff0d;
}
.form-control::-webkit-file-upload-button {
    height: 40px;
    color: var(--dark);
    background-color: var(--white);
    border: 4px solid var(--light);
    border-radius: .625rem;
}

.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
    background-color: var(--white);
}

.form-group[class*="has-icon-"].has-icon-left .form-control {
    padding-left: 3rem;
}

.form-group[class*="has-icon-"].has-icon-left .form-control-icon {
    left: 0;
}

.form-group[class*="has-icon-"].has-icon-right .form-control {
    padding-right: 3rem;
}

.form-group[class*="has-icon-"].has-icon-right .form-control-icon {
    right: 0;
}

.form-group[class*="has-icon-"] .form-control:focus~.form-control-icon i,
.form-group[class*="has-icon-"] .form-control:focus~.form-control-icon svg {
    color: var(--primary);
}

.form-group[class*="has-icon-"] .form-control.form-control-xl {
    padding-left: 3rem;
}

.form-group[class*="has-icon-"] .form-control.form-control-xl~.form-control-icon i {
    font-size: 1.6rem;
}

.form-group[class*="has-icon-"] .form-control.form-control-xl~.form-control-icon i:before {
    color: #a6a8aa;
}

.form-group[class*="has-icon-"] .form-control-icon {
    display: flex;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding: 0 .8rem;
}

.form-group.form-control-lg-icon[class*="has-icon-"] .form-control-icon {
    top: 15px;
    transform: none;
}

.form-group[class*="has-icon-"] .form-control-icon i,
.form-group[class*="has-icon-"] .form-control-icon svg {
    width: 1.4rem;
    color: var(--gray);
    font-size: 1.4rem;
}
.inputgroup {
    position: relative;
    overflow: hidden;
}
.inputgroup .form-control{
    padding-right: 2.5rem;
}
.inputgroup i{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    color: var(--font-white);
    width: 44px;
    background-color: var(--primary);
    border-top-right-radius: .625rem;
    border-bottom-right-radius: .625rem;
}
.form-check {
    padding-left: 2em;
}

.form-check-input {
    width: 1.4em;
    height: 1.4em;
    margin-top: 0;
    background-color: var(--light);
    border: 1px solid var(--border);
}

.form-check .form-check-input {
    margin-left: -2em;
}

label.form-check-label {
    font-size: 15px;
    font-weight: 500;
    color: var(--gray);
}

.form-check-input:checked {
    background-color: var(--primary);
    border-color: var(--primary);
}
.form-switch .form-check-input{
    position: relative;
    width: 70px;
    height: 30px;
    border-radius: 50px;
    background-color: rgb(200, 200, 200);
    border: none;
}
.form-switch .form-check-input:checked{
    background-color: var(--primary);
}
.form-switch .form-check-input::after{
    content: "OFF";
    position: absolute;
    right: .75rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 13px;
    font-weight: 500;
    color: var(--font-white);
}
.form-switch .form-check-input:checked::after,
.form-switch.yes-no .form-check-input:checked::after{
    content: unset;
}
.form-switch .form-check-input:checked::before{
    content: "ON";
    position: absolute;
    left: .75rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 13px;
    font-weight: 500;
    color: var(--font-white);
}
.form-switch.yes-no .form-check-input::after{
    content: "NO";
}
.form-switch.yes-no .form-check-input:checked::before{
    content: "YES";
}
.form-switch .form-check-input{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
/*--------------------------------------------------------------
    12. Button
--------------------------------------------------------------*/

.btn-primary {
    --bs-btn-color: var(--font-white);
    --bs-btn-bg: var(--primary);
    --bs-btn-border-color: var(--primary);
    --bs-btn-hover-color: var(--font-white);
    --bs-btn-hover-bg: var(--primary);
    --bs-btn-hover-border-color: var(--primary);
    --bs-btn-focus-shadow-rgb: 49, 132, 253;
    --bs-btn-active-color: var(--font-white);
    --bs-btn-active-bg: var(--primary);
    --bs-btn-active-border-color: var(--primary);
    --bs-btn-active-shadow: unset;
    --bs-btn-disabled-color: var(--font-white);
    --bs-btn-disabled-bg: var(--primary);
    --bs-btn-disabled-border-color: var(--primary);
}
.btn-light {
    --bs-btn-color: var(--dark);
    --bs-btn-bg: var(--light);
    --bs-btn-border-color: var(--light);
    --bs-btn-hover-color: var(--dark);
    --bs-btn-hover-bg: var(--light);
    --bs-btn-hover-border-color: var(--light);
    --bs-btn-focus-shadow-rgb: 211, 212, 213;
    --bs-btn-active-color: var(--dark);
    --bs-btn-active-bg: var(--light);
    --bs-btn-active-border-color: var(--light);
    --bs-btn-active-shadow: unset;
    --bs-btn-disabled-color: var(--dark);
    --bs-btn-disabled-bg: var(--light);
    --bs-btn-disabled-border-color: var(--light);
}
.btn-danger {
    --bs-btn-color: var(--font-white);
    --bs-btn-bg: var(--danger);
    --bs-btn-border-color: var(--danger);
    --bs-btn-hover-color: var(--font-white);
    --bs-btn-hover-bg: var(--danger);
    --bs-btn-hover-border-color: var(--danger);
    --bs-btn-focus-shadow-rgb: 225, 83, 97;
    --bs-btn-active-color: var(--font-white);
    --bs-btn-active-bg: var(--danger);
    --bs-btn-active-border-color: var(--danger);
    --bs-btn-active-shadow: unset;
    --bs-btn-disabled-color: var(--font-white);
    --bs-btn-disabled-bg: var(--danger);
    --bs-btn-disabled-border-color: var(--danger);
}
.btn-success {
    --bs-btn-color: var(--font-white);
    --bs-btn-bg: var(--success);
    --bs-btn-border-color: var(--success);
    --bs-btn-hover-color: var(--font-white);
    --bs-btn-hover-bg: var(--success);
    --bs-btn-hover-border-color: var(--success);
    --bs-btn-focus-shadow-rgb: 49, 132, 253;
    --bs-btn-active-color: var(--font-white);
    --bs-btn-active-bg: var(--success);
    --bs-btn-active-border-color: var(--success);
    --bs-btn-active-shadow: unset;
    --bs-btn-disabled-color: var(--font-white);
    --bs-btn-disabled-bg: var(--success);
    --bs-btn-disabled-border-color: var(--success);
}
.btn-info {
    --bs-btn-color: var(--font-white);
    --bs-btn-bg: var(--info);
    --bs-btn-border-color: var(--info);
    --bs-btn-hover-color: var(--font-white);
    --bs-btn-hover-bg: var(--info);
    --bs-btn-hover-border-color: var(--info);
    --bs-btn-focus-shadow-rgb: 49, 132, 253;
    --bs-btn-active-color: var(--font-white);
    --bs-btn-active-bg: var(--info);
    --bs-btn-active-border-color: var(--info);
    --bs-btn-active-shadow: unset;
    --bs-btn-disabled-color: var(--font-white);
    --bs-btn-disabled-bg: var(--info);
    --bs-btn-disabled-border-color: var(--info);
}
.btn-warning {
    --bs-btn-color: var(--font-white);
    --bs-btn-bg: var(--warning);
    --bs-btn-border-color: var(--warning);
    --bs-btn-hover-color: var(--font-white);
    --bs-btn-hover-bg: var(--warning);
    --bs-btn-hover-border-color: var(--warning);
    --bs-btn-focus-shadow-rgb: 49, 132, 253;
    --bs-btn-active-color: var(--font-white);
    --bs-btn-active-bg: var(--warning);
    --bs-btn-active-border-color: var(--warning);
    --bs-btn-active-shadow: unset;
    --bs-btn-disabled-color: var(--font-white);
    --bs-btn-disabled-bg: var(--warning);
    --bs-btn-disabled-border-color: var(--warning);
}
.btn-outline-primary {
    --bs-btn-color: var(--primary);
    --bs-btn-border-color: var(--primary);
    --bs-btn-hover-color: var(--font-white);
    --bs-btn-hover-bg: var(--primary);
    --bs-btn-hover-border-color: var(--primary);
    --bs-btn-focus-shadow-rgb: 13,202,240;
    --bs-btn-active-color: var(--font-white);
    --bs-btn-active-bg: var(--primary);
    --bs-btn-active-border-color: var(--primary);
    --bs-btn-active-shadow: unset;
    --bs-btn-disabled-color: var(--primary);
    --bs-btn-disabled-border-color: var(--primary);
}
.btn-outline-danger {
    --bs-btn-color: var(--danger);
    --bs-btn-border-color: var(--danger);
    --bs-btn-hover-color: var(--font-white);
    --bs-btn-hover-bg: var(--danger);
    --bs-btn-hover-border-color: var(--danger);
    --bs-btn-focus-shadow-rgb: 13,202,240;
    --bs-btn-active-color: var(--font-white);
    --bs-btn-active-bg: var(--danger);
    --bs-btn-active-border-color: var(--danger);
    --bs-btn-active-shadow: unset;
    --bs-btn-disabled-color: var(--danger);
    --bs-btn-disabled-border-color: var(--danger);
}
.btn-outline-success {
    --bs-btn-color: var(--success);
    --bs-btn-border-color: var(--success);
    --bs-btn-hover-color: var(--font-white);
    --bs-btn-hover-bg: var(--success);
    --bs-btn-hover-border-color: var(--success);
    --bs-btn-focus-shadow-rgb: 13,202,240;
    --bs-btn-active-color: var(--font-white);
    --bs-btn-active-bg: var(--success);
    --bs-btn-active-border-color: var(--success);
    --bs-btn-active-shadow: unset;
    --bs-btn-disabled-color: var(--success);
    --bs-btn-disabled-border-color: var(--success);
}
.btn-outline-warning {
    --bs-btn-color: var(--warning);
    --bs-btn-border-color: var(--warning);
    --bs-btn-hover-color: var(--font-white);
    --bs-btn-hover-bg: var(--warning);
    --bs-btn-hover-border-color: var(--warning);
    --bs-btn-focus-shadow-rgb: 13,202,240;
    --bs-btn-active-color: var(--font-white);
    --bs-btn-active-bg: var(--warning);
    --bs-btn-active-border-color: var(--warning);
    --bs-btn-active-shadow: unset;
    --bs-btn-disabled-color: var(--warning);
    --bs-btn-disabled-border-color: var(--warning);
}
.btn-outline-info {
    --bs-btn-color: var(--info);
    --bs-btn-border-color: var(--info);
    --bs-btn-hover-color: var(--font-white);
    --bs-btn-hover-bg: var(--info);
    --bs-btn-hover-border-color: var(--info);
    --bs-btn-focus-shadow-rgb: 13,202,240;
    --bs-btn-active-color: var(--font-white);
    --bs-btn-active-bg: var(--info);
    --bs-btn-active-border-color: var(--info);
    --bs-btn-active-shadow: unset;
    --bs-btn-disabled-color: var(--info);
    --bs-btn-disabled-border-color: var(--info);
}
.btn-link {
    --bs-btn-font-weight: 400;
    --bs-btn-color: var(--primary);
    --bs-btn-bg: transparent;
    --bs-btn-border-color: transparent;
    --bs-btn-hover-color:var(--white);
    --bs-btn-hover-border-color: transparent;
    --bs-btn-active-color: var(--white);
    --bs-btn-active-border-color: transparent;
    --bs-btn-disabled-color: #6c757d;
    --bs-btn-disabled-border-color: transparent;
    --bs-btn-box-shadow: none;
    --bs-btn-focus-shadow-rgb: 49, 132, 253;
    text-decoration: none;
}
.btn-transparent{
    --bs-btn-bg: transparent;
    --bs-btn-border-color: transparent;
    --bs-btn-hover-border-color: transparent;
    border-radius: 0 !important; 
}
.btn-transparent:hover,
.btn-transparent:active{
    background-color: transparent !important;
    border-color: transparent !important;
}
.btn-transparent.btn-primary{
    --bs-btn-color: var(--primary);
    --bs-btn-hover-color:var(--primary);
}
.btn-transparent.btn-primary:hover,
.btn-transparent.btn-primary:active{
    color: var(--primary) !important;
}
.btn-transparent.btn-danger{
    --bs-btn-color: var(--danger);
    --bs-btn-hover-color:var(--danger);
}
.btn-transparent.btn-danger:hover,
.btn-transparent.btn-danger:active{
    color: var(--danger) !important;
}
.btn-transparent.btn-success{
    --bs-btn-color: var(--success);
    --bs-btn-hover-color:var(--success);
}
.btn-transparent.btn-success:hover,
.btn-transparent.btn-success:active{
    color: var(--success) !important;
}
.btn-transparent i{
    font-size: 1.25rem !important;
}
.btn-group-lg>.btn,
.btn-lg {
    padding: 0.625rem 1.25rem !important;
    font-size: 1.25rem;
    border-radius: .625rem;
}

.btn-sm {
    padding: 0.407rem 0.5rem !important;
    font-size: 0.875rem;
    border-radius: .325rem;
}

.btn {
    font-weight: 500;
    border-radius: 0.625rem;
    padding: 0.485rem 1rem;
    font-size: 15px;
    box-shadow: unset;
}

.btn.btn-icon-text {
    display: flex;
    align-items: center;
}

.btn.btn-icon-text i {
    margin-right: .5rem;
    font-size: 1.225rem;
    line-height: 1.225rem;
}

.btn.btn-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    height: 32px;
    width: 32px;
}

.btn.btn-icon i {
    font-size: 1rem;
    line-height: 1rem;
}

.btn.btn-icon-lg {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    height: 40px;
    width: 40px;
}
.btn.btn-icon-lg i,
.btn.btn-icon-lg.bx{
    font-size: 1.15rem;
    line-height: 1.15rem;
}
@media (max-width: 767.98px) {
    .btn-group .btn {
        --bs-btn-padding-y: 0.25rem;
        --bs-btn-padding-x: 0.5rem;
        --bs-btn-font-size: 0.875rem;
        --bs-btn-border-radius: 0.25rem;
    }
}
/*--------------------------------------------------------------
    13. Switch Button 1
--------------------------------------------------------------*/
.switch.btn-sm {
    min-height: 36px !important;
}

.switch-on.btn.btn-sm {
    padding-right: 1.5rem !important;
    line-height: 22px;
}

.switch-off.btn.btn-sm {
    padding-left: 1.5rem !important;
    line-height: 22px;
}

.switch.btn.btn-light,
.switch.btn.btn-outline-light {
    border-color: var(--border) !important;
}

.switch-on.btn {
    padding-right: 2rem;
    line-height: 18px;
}

.switch-off.btn {
    padding-left: 2rem;
    line-height: 18px;
}
.switch-handle{
    background-color: var(--white) !important;
}
/*--------------------------------------------------------------
    14. Modal
--------------------------------------------------------------*/
.modal-content{
    background-color: var(--white);
    border-color: var(--border);
}
.modal-header{
    border-bottom-color: var(--border);
}
.modal .modal-header .modal-title{
    position: relative;
    font-size: 20px;
    font-weight: 600;
    padding-left: 1rem;
}
.modal .modal-header .modal-title::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 20px;
    background-color: var(--primary);
}
.modal .modal-body .modal-content{
    border-color: transparent;
}
.modal .modal-footer{
    border-top-color: var(--border);
}
html.dark .btn-close{
    filter: invert(1);
}
/*--------------------------------------------------------------
    15. Login Screen
--------------------------------------------------------------*/
.auth-box-bg{
    /* background: url(../../public/logo/loginbg.png); */
    max-width: 100%;
    background-position: bottom;
    background-repeat: no-repeat;
}
.auth {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    height: 100vh;
}
.auth .auth-box {
    width: 500px;
    margin: 0 auto 150px;
}
.auth .auth-box .card,
.auth .auth-box .card-header{
    background-color: transparent;
}
.auth .auth-box .card-header{
    padding: 0;
}
.auth .auth-box .card-header .auth-logo{
    text-align: center;
    margin-bottom: 2.5rem;
}
.auth .auth-box .card-header .auth-logo .logo-mini{
   max-width: 100%;
   height: 60px;
}
html.dark .auth .auth-box .card-header .auth-logo .logo-mini path:last-child{
    fill: var(--font-white);
}
.auth .auth-box .card-body{
    padding: 2rem;
    background-color: var(--white);
    border-radius: 0.825rem;
    box-shadow: 0 12px 34px 0 rgb(0 0 0 / 6%);
}
.auth .auth-box .card-body .auth-title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: .75rem;
    text-align: center;
}
.auth .auth-box .card-body .auth-subtitle {
    font-size: 16px;
    color: var(--gray);
    margin-bottom: 2rem;
    text-align: center;
}
.auth .auth-box .card-body .form-control,
.auth .auth-box .card-body .form-check-input{
    background-color: var(--light2) !important;
}
.auth .auth-box .card-body .form-check-input:checked{
    background-color: var(--primary) !important
}
.auth .auth-box .input-prefix{
    position: relative;
}
.auth .auth-box .input-prefix .form-control{
    padding-left: 2.75rem;
}
.auth .auth-box .input-prefix.input-prefix-right .form-control{
    padding-right: 2.75rem;
}
.auth .auth-box .input-prefix i {
    position: absolute;
    left: 0.25rem;
    bottom: 0;
    font-size: 20px;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--gray);
}
.auth .auth-box .input-prefix.input-prefix-right .icon-prefix-right{
    left: unset;
    right: 0.25rem;
    color: var(--primary);
}
@media (max-width: 767px) {

}
@media (max-width: 400px) {
    .auth .auth-box .card-body{
        padding: 1rem;
    }
}
@media (max-width:375px) {

}
/*--------------------------------------------------------------
    16. Pagination
--------------------------------------------------------------*/
.pagination{
    --bs-pagination-color:#c0c3c7;
    --bs-pagination-padding-x: 0.75rem;
    --bs-pagination-padding-y: 0.375rem;
    --bs-pagination-font-size: 1rem;
    --bs-pagination-color: #c0c3c7;
    --bs-pagination-bg: #fff;
    --bs-pagination-border-width: 1px;
    --bs-pagination-border-color: #dee2e6;
    --bs-pagination-border-radius: 0.375rem;
    --bs-pagination-hover-color: #000;
    --bs-pagination-hover-bg: #e9ecef;
    --bs-pagination-hover-border-color: #dee2e6;
    --bs-pagination-focus-color: var(--bs-link-hover-color);
    --bs-pagination-focus-bg: #e9ecef;
    --bs-pagination-focus-box-shadow: 0 0 0 0.25remrgba(13, 110, 253, 0.25);
    --bs-pagination-active-color: #fff;
    --bs-pagination-active-bg: #0d6efd;
    --bs-pagination-active-border-color: #0d6efd;
    --bs-pagination-disabled-color: #6c757d;
    --bs-pagination-disabled-bg: #fff;
    --bs-pagination-disabled-border-color: #dee2e6;
    display: flex;
    padding-left: 0;
    list-style: none;
}
.page-item:nth-child(2) .page-link{
    background-color:var(--primary) !important;
}
.page-item:nth-child(2) .page-link:hover{
  color: #fff !important;
}
.pagination-custom{
    margin-top: 1.5rem;
}
.rc-pagination {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    list-style: none;
    padding: 0;
    margin: 0;
}
.rc-pagination-item{
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: center;
    min-width: 40px;
    height: 40px;
    color: var(--gray);
    font-weight: 500;
    border-radius: 50px;
}
.rc-pagination-prev:before,
.rc-pagination-next:before{
    font-family: 'boxicons' !important;
    position: absolute;
    cursor: pointer;
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: var(--white);
    border-radius: 50px;
}
.rc-pagination-next:before{
    content: "\\ea50";
}
.rc-pagination-prev:before{
    content: "\\ea4d";
}
.rc-pagination-item,
.rc-pagination-prev,
.rc-pagination-jump-prev,
.rc-pagination-jump-next {
    margin-right: 8px;
}
.rc-pagination-item.rc-pagination-item-active{
    background-color: var(--primary);
    color: var(--font-white);
}
.rc-pagination-item.rc-pagination-item-active a{
    color: var(--font-white);
}
.rc-pagination-prev.rc-pagination-disabled,
.rc-pagination-next.rc-pagination-disabled{
    color: var(--gray);
    opacity: 0.75;
}
.paggination-btn{
    min-width: 40px;
    height: 40px;
    overflow: hidden;
    background-color: transparent;
    color: var(--gray);
    border-radius: .625rem;
    border: transparent;
}
.rc-pagination-jump-prev button,
.rc-pagination-jump-next button {
    border-color: transparent;
    background-color: transparent;
}

.rc-pagination-jump-next button:after,
.rc-pagination-jump-prev button:after {
    display: block;
    content: "•••";
    font-size: 14px;
    color: var(--gray);
}
.rc-pagination-prev, .rc-pagination-next, .rc-pagination-item, .rc-pagination-jump-prev, .rc-pagination-jump-next {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    height: 40px;
    color: var(--gray);
}

/*--------------------------------------------------------------
    17. Page Not Found
--------------------------------------------------------------*/
.error{
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.no-found{
    text-align: center;
    padding: 3rem 0;
}
.no-found img{
    height: 200px;
}
.no-found p{
    font-size: 20px;
    font-weight: 600;
    margin-top: 2rem;
    margin-bottom: 0;
}
.Image-Map{
    width: 40px;
    height: 40px;
}

/*--------------------------------------------------------------
    18. Loader
--------------------------------------------------------------*/
.loader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    background-color:var(--white);
    z-index: 999;
}
.loader::before {
    content: "";
    position: absolute;
    background: linear-gradient(90deg,
      rgba(245, 245, 245, 0) 0%,
      rgba(245, 245, 245, 0.75) 50%,
      rgba(245, 245, 245, 0) 100%
    );
    height: 100%;
    width: 100%;
    z-index: 1;
    animation: skeleton 1.5s infinite;
}
.dark .loader::before {
    background: linear-gradient(90deg,
      rgba(20, 18, 24, 0) 0%,
      rgba(20, 18, 24, 0.5) 50%,
      rgba(20, 18, 24, 0) 100%
    );
}
/* .loader:after {
    content: "";
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-image: url('../public/logo/mini-logo.svg');
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    width: 40px;
    height: 40px;
}
.loader:before{
    content: "";
    position: fixed;
    top: calc(50% - 40px);
    left: calc(50% - 40px);
    border: 2px solid var(--primary);
    border-top-color: transparent;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    -webkit-animation: animate-preloader 1s linear infinite;
    animation: animate-preloader 1s linear infinite;
} */
.loader.table-loader{
    position: absolute;
    border-radius: .625rem;
    min-height: calc(100vh - 227px);
}
.loader.table-loader:after,
.loader.table-loader:before{
    position: absolute;
}
@keyframes skeleton {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}

@keyframes animate-preloader {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
/*--------------------------------------------------------------
    19. Sweet Alert
--------------------------------------------------------------*/
.swal2-popup{
    background-color: var(--white) !important;
    color: var(--dark) !important;
    border-radius: .625rem !important;
}
/*--------------------------------------------------------------
    20. React Switch
--------------------------------------------------------------*/
.react-switch .react-switch-off,
.react-switch .react-switch-on{
    display: flex;
    justify-content: center;
    font-size: 13px;
    font-weight: 500;
    line-height: 30px;
    color: var(--font-white);
}
.react-switch .react-switch-off{
    margin-right: 4px;
}
.react-switch .react-switch-on{
    margin-left: 4px;
}
.react-switch.react-switch-small .react-switch-handle{
    box-shadow: unset !important;
    top: 3px !important;
    left: 2px;
    width: 18px !important;
    height: 18px !important;
}
/*--------------------------------------------------------------
    21. Darkmode
--------------------------------------------------------------*/
.darkmode-switch{
    position: relative;
    width: 40px;
    height: 40px;
    margin-right: 1.5rem;
    transition: background-color 0.3s ease-in-out;
}
.darkmode-switch #darkMode{
    border: none;
    background: transparent;
}
.darkmode-switch #darkMode::before{
    content: "\\ee4e";
    font-family: boxicons!important;
    position:absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--gray);
    font-size:1.35rem;
}  
.darkmode-switch #darkMode.clicked::before {
    content: "\\eebe";
}
/*--------------------------------------------------------------
    24. Multi Select Picker
--------------------------------------------------------------*/
.customMulSelect .react-select__control{
    padding: 0.1rem 0.25rem;
    min-height: 40px;
    border-radius: 0.625rem !important;
    color: var(--dark);
    font-weight: 500;
    background-color: var(--light) !important;
    border: none !important;
    box-shadow: unset !important;
}
.customMulSelect .react-select__control .react-select__indicator.react-select__dropdown-indicator svg{
    width: 16px;
    transition: transform 0.2s ease-out;
    color: hsl(0, 0%, 40%);
}
.customMulSelect .react-select__control.react-select__control--menu-is-open .react-select__indicator.react-select__dropdown-indicator svg{
    transform: rotate(180deg);
}
.react-select__indicator-separator{
    background-color: var(--border) !important;
}
.react-select__multi-value{
    background-color: var(--white) !important;
}
.react-select__multi-value__label{
    color: var(--dark) !important;
}
.react-select__menu{
    background-color: var(--white) !important;
    border-color: var(--border) !important;
    border-radius: .625rem !important;
    z-index: 9 !important;
}
.react-select__option{
    color: var(--dark);
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
}
.customMulSelect.rs-novalidated .react-select__control{
    border: 1px solid #dc3545 !important;
}
.react-select__input-container,
.react-select__single-value{
    color: var(--dark) !important;
}
/*--------------------------------------------------------------
    22. Toastify toast
--------------------------------------------------------------*/
.Toastify__toast-theme--light{
    background-color: var(--white) !important;
    color: var(--dark) !important;
}
.Toastify__close-button--light{
    color: var(--dark) !important;
    opacity: 1 !important;
}
/*--------------------------------------------------------------
    22. RS Dropdown
--------------------------------------------------------------*/
.rs-dropdown-menu{
    background-color: var(--white);
    border-radius: .625rem;
    padding: .5rem !important;
    z-index: 1060 !important;
}
.rs-dropdown-menu .rs-dropdown-item{
    font-size: 15px;
    color: var(--dark);
    font-weight: 500;
    border-radius: .5rem;
}
.rs-dropdown-menu .rs-dropdown-item:hover{
    background-color: rgb(69 109 255 / 7%) !important;
    color: var(--primary) !important;
}
.rs-dropdown-item:focus-visible, .rs-dropdown-item.rs-dropdown-item-focus{
    background-color: rgb(69 109 255 / 7%) !important;
    color: var(--primary) !important;
}
/*--------------------------------------------------------------
    23. Dashboard
--------------------------------------------------------------*/
.vv-dashboard .card{
    margin-bottom: 1.5rem;
}
.vv-dashboard .card .card-body .counter{
    display: flex;
}
.vv-dashboard .card .card-body .counter .counter-media{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    background-color: var(--light);
    border-radius: .625rem;
    font-size: 24px;
}
.vv-dashboard .card .card-body .counter.orange .counter-media{
    background-color: #ffb05c33;
    color: #FFB15C;
}
.vv-dashboard .card .card-body .counter.pink .counter-media{
    background-color: #db73ff33;
    color: #DB73FF;
}
.vv-dashboard .card .card-body .counter.green .counter-media{
    background-color: #1fd9a333;
    color: #1FD9A3;
}
.vv-dashboard .card .card-body .counter.blue .counter-media{
    background-color: #6a9bf433;
    color: #6A9BF4;
}
.vv-dashboard .card .card-body .counter .counter-content{
    margin-left: 1.25rem;
}
.vv-dashboard .card .card-body .counter .counter-content h3{
    font-size: 24px;
    font-weight: 700;
    margin-bottom: .15rem;
}
.vv-dashboard .card .card-body .counter .counter-content p{
    font-size: 14px;
    font-weight: 500;
    color: var(--gray);
    margin-bottom: 0;
}
.vv-dashboard .card .card-body .chart-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
}
.vv-dashboard .card .card-body .chart-title h4{
    font-size: 18px;
    font-weight: 700;
    margin: 0;
}
.vv-dashboard .card .card-body .attch-link .attch-link-title {
    display: flex;
    align-items: center;
}
.vv-dashboard .card .card-body .attch-link .attch-link-title i {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    font-size: 20px;
}
.vv-dashboard .card .card-body .attch-link.green .attch-link-title i, 
.vv-dashboard .card .card-body .attch-link.green .attch-link-content ul li a:hover {
    color: #1FD9A3;
}
.vv-dashboard .card .card-body .attch-link.red .attch-link-title i, 
.vv-dashboard .card .card-body .attch-link.red .attch-link-content ul li a:hover {
    color: #FF5C84;
}
.vv-dashboard .card .card-body .attch-link .attch-link-title h4 {
    font-size: 18px;
    font-weight: 700;
    margin-left: 0.75rem;
    margin-bottom: 0;
}
.vv-dashboard .card .card-body .attch-link .attch-link-content ul {
    position: relative;
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
    margin-left: 12px;
}
.vv-dashboard .card .card-body .attch-link .attch-link-content ul:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 1px;
    height: calc(100% - 12px);
    background-color: var(--border);
}
.vv-dashboard .card .card-body .attch-link .attch-link-content ul li {
    position: relative;
    padding-left: 24px;
    margin: 0.5rem 0;
}
.vv-dashboard .card .card-body .attch-link .attch-link-content ul li:before {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 15px;
    height: 1px;
    background-color: var(--border);
}
.vv-dashboard .card .card-body .attch-link .attch-link-content ul li a {
    font-weight: 500;
    color: var(--font-gray);
    transition: .3s ease;
}
.vv-dashboard .card .card-body .attch-link.green .attch-link-title i, 
.vv-dashboard .card .card-body .attch-link.green .attch-link-content ul li a:hover {
    color: #1FD9A3;
}
.vv-dashboard .card .card-body .attch-link.red .attch-link-title i,
.vv-dashboard .card .card-body .attch-link.red .attch-link-content ul li a:hover {
    color: #FF5C84;
}
/*--------------------------------------------------------------
    25. Popover
--------------------------------------------------------------*/
.popover{
    border-color: var(--border);
}
.popover-body{
    background-color: var(--white);
    color: var(--dark);
}
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after, .bs-popover-top>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after, .bs-popover-left>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after, .bs-popover-right>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after, .bs-popover-bottom>.popover-arrow::after{
    border-top-color: var(--border);
}
/*--------------------------------------------------------------
    25. Project Grid List
--------------------------------------------------------------*/
.project-grid-list .card{
    margin-bottom: 1.5rem;
}
.project-grid-list .project-list-item {
    display: flex;
    align-items: center;
}
.project-grid-list .project-list-item:hover{
    color: unset;
}
.project-grid-list .project-list-item img{
    width: 50px;
    height: 50px;
    border-radius: .625rem;
    margin-right: 1rem;
}
.project-grid-list .project-list-item .project-list-content h6{
    font-size: 17px;
    font-weight: 600;
    margin-bottom: 0.25rem;
}
.project-grid-list .project-list-item .project-list-content p{
    margin: 0;
}
/* ==================================================
    25. User Details Modal
================================================== */
.user-details-modal .modal-body .user-details {
    float: left;
    width: 100%;
}
.user-details-modal .modal-body .user-details p {
    position: relative;
    float: left;
    min-width: 30%;
    font-weight: 600;
}
.user-details-modal .modal-body .user-details p:after {
    content: ":";
    position: absolute;
    top: 0;
    right: 15px;
    color: var(--dark);
}
.user-details-modal .modal-body .user-details span {
    float: left;
    width: 70%;
}
/* ==================================================
    25. Date Range Picker
================================================== */
.daterangepicker {
    border-radius: .5rem;
    font-family: inherit;
    background-color: var(--white);
    border: unset;
    font-size: 16px;
    margin-top: 0;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12), 0 0 10px rgba(0, 0, 0, 0.06);
}
.daterangepicker.opensright:before,
.daterangepicker.opensright:after{
    content: unset;
}
.daterangepicker .ranges ul{
    padding: .5rem;
}
.daterangepicker .ranges li{
    font-size: 14px;
    line-height: normal;
    font-weight: 500;
    color: var(--dark);
    border-radius: .5rem;
}
.daterangepicker.show-ranges.ltr .drp-calendar.left{
    border-left-color: var(--border);
}
.daterangepicker .ranges li:hover {
    background-color: rgb(69 109 255 / 7%);
    color: var(--primary);
}
.daterangepicker .ranges li.active {
    background-color: var(--primary);
    color: var(--font-white);
}
.daterangepicker .calendar-table {
    background-color: var(--white);
    border-color: transparent;
}

.daterangepicker .calendar-table .next span,
.daterangepicker .calendar-table .prev span {
    color: var(--font-white);
    border-color: var(--dark);
}
.daterangepicker .drp-buttons .btn{
    font-size: 13px;
    padding: 0.407rem 0.75rem !important;
}
.daterangepicker .drp-buttons .btn.btn-default{
    color: var(--dark);
    background-color: var(--light);
}
.daterangepicker td.in-range{
    background-color: rgb(69 109 255 / 7%);
    color: var(--dark);
}
.daterangepicker td.off,
.daterangepicker td.off.in-range,
.daterangepicker td.off.start-date,
.daterangepicker td.off.end-date {
    background-color: var(--white);
    color: var(--gray);
}

.daterangepicker td.active,
.daterangepicker td.active:hover {
    background-color: var(--primary);
    color: var(--font-white);
}

.daterangepicker .drp-buttons {
    border-color: var(--border);
}
.daterangepicker .drp-selected{
    font-size: 13px;
    font-weight: 500;
}
.daterangepicker td.available:hover,
.daterangepicker th.available:hover {
    color: var(--dark);
    background-color: var(--light);
}
.daterangepicker .calendar-table th{
    border-radius: 0;
}
.daterangepicker .calendar-table th,
.daterangepicker .calendar-table td{
    min-width: 32px;
    width: 32px;
    height: 32px;
    line-height: 0;
}
.daterangepicker .calendar-table td{
    font-size: 13px;
    font-weight: 500;
}
.daterangepicker td.start-date.end-date {
    border-radius: .525rem;
}
.daterangepicker td.start-date {
    border-radius: .525rem 0 0 .525rem;
}
.daterangepicker td.end-date {
    border-radius: 0 .525rem .525rem 0;
}
.daterangepicker:after{
    border-bottom: 6px solid var(--border) !important;
}
.daterangepicker:before {
    border-bottom: 7px solid var(--border);
}
.daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect, .daterangepicker select.ampmselect{
    background-color: var(--white);
    border-color: var(--border);
    border-radius: 0.325rem;
    color: var(--dark);
}

/* ==================================================
    25. Dashboard
================================================== */
.vi-dashboard .countdata{
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--light);
    border: 1px solid var(--border);
    border-radius: 1rem;
    padding: 1.25rem;
}
.vi-dashboard .countdata.blue{
    background-color: rgb(0 143 251 / 3%);
    border-color: #008FFB;   
}
.vi-dashboard .countdata.red{
    background-color: rgb(255 69 96 / 3%);
    border-color: #FF4560;   
}
.vi-dashboard .countdata.purple{
    background-color: rgb(119 93 208 / 3%);
    border-color: #775DD0;   
}
.vi-dashboard .countdata .countdata-content p{
    font-size: 1rem;
    font-weight: 500;
    color: var(--dark);
    margin-bottom: .25rem;
    text-transform: uppercase;
}
.vi-dashboard .countdata .countdata-content h3{
    font-size: 1.5rem;
    font-weight: 700;
    color: #2E96FF;
    margin-bottom: 1rem;
}
.vi-dashboard .countdata .countdata-content ul{
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
}
.vi-dashboard .countdata .countdata-content ul li{
    display: flex;
    align-items: center;
    margin-right: .5rem;
    border-right: 1px solid var(--border);
    padding-right: .5rem;
}
.vi-dashboard .countdata .countdata-content ul li:last-child{
    border-right: none;
    margin: 0;
    padding: 0;
}
.vi-dashboard .countdata .countdata-content ul li p{
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: normal;
    font-weight: 500;
    color: #6C737D;
    text-transform: capitalize;
    margin: 0;
}
.vi-dashboard .countdata .countdata-content ul li p span{
    display: flex;
    align-items: center;
    margin-right: .25rem;
}
.vi-dashboard .countdata .countdata-content ul li p span i{
    font-size: 18px;
    margin-right: .25rem;
}
.vi-dashboard .countdata .countdata-content ul li p .txtgreen{
    color: #08A975;
}
.vi-dashboard .countdata .countdata-content ul li p .txtred{
    color: #EB6262;
}
.vi-dashboard .countdata .countdata-chart{
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
}

.chart-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.chart-title h4{
    position: relative;
    font-size: 20px;
    font-weight: 600;
    color:var(--dark);
    padding-left: 1rem;
    margin: 0;
}
.chart-title h4::before{
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 20px;
    background-color: var(--primary);
}
.chart-title p{
    font-size: 14px;
    font-weight: 400;
    color: var(--gray);
    margin-top: .15rem;
    margin-bottom: 0;
}
.chart-title .chartfilter{
    display: flex;
    align-items: center;
}
.apexcharts-tooltip{
    background-color: #fff !important;
    border: 1px solid #DFEDFC !important;
    border-radius: 10px !important;
}
.apexcharts-text{
    font-weight: 500 !important;
}
.apexcharts-legend{
    padding: 0 !important;
}
.tooltipbox h6{
    font-size: 12px;
    font-weight: 500;
    margin: 0;
    padding: 5px 10px;
    background-color: #EBF5FF;
    color: #24272C;
    border-bottom: 1px solid #DFEDFC;
}
.tooltipbox .tooltipbody{
    padding: 5px 10px;
}
.tooltipbox .tooltipbody p{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: #6C737D;
    margin: 0;
}
.tooltipbox .tooltipbody p .legend{
    display: flex;
    width: 10px;
    height: 10px;
    border-radius: 50px;
    background-color: var(--border);
    margin-right: 8px;
}
.tooltipbox .tooltipbody p .tooltiptext{
    color: #24272C;
}


.chartfilter .chartlegend{
    display: flex;
    align-items: center;
}
.chartfilter .chartlegend p{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: var(--gray);
    margin: 0;
    padding-left: 1rem;
}
.chartfilter .chartlegend p span{
    display: flex;
    width: 10px;
    height: 10px;
    border-radius: 50px;
    background-color: var(--border);
    margin-right: 8px;
}
.chartfilter .form-control, .chartfilter .form-select, .chartfilter .rs-picker-default .rs-picker-toggle{
    border-color: var(--border);
    min-height: 36px;
}
.chartfilter .rs-picker-default .rs-picker-toggle.rs-btn{
    padding-top: 7px;
    padding-bottom: 7px;
    min-height: 36px;
}
.chartfilter .rs-picker-default:not(.rs-picker-disabled) .rs-btn:hover,
.chartfilter .rs-picker-default:not(.rs-picker-disabled) .rs-btn:focus {
    border-color: var(--border);
}
.chartfilter .rs-picker-default .rs-picker-toggle.rs-btn .rs-picker-toggle-caret{
    top: 7px;
}
/* ==================================================
    25. Challan View
================================================== */
.echallan-view{
    border: 1px solid var(--border);
    padding: 1.5rem;
    border-radius: .625rem;
}
.echallan-view .echallan-view-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--border);
    padding-bottom: 1rem;
}
.echallan-view .echallan-view-header p{
    margin: 0;
    font-weight: 600;
}
.echallan-view .echallan-view-header .echallan-view-header-l{
    display: flex;
    align-items: center;
}
.echallan-view .echallan-view-header .echallan-view-header-l p{
    position: relative;
    margin: 0;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 18px;
}
.echallan-view .echallan-view-header .echallan-view-header-l p::before{
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 2px;
    height: 26px;
    background-color: var(--border);
}
.echallan-view .echallan-view-header .echallan-view-header-l span{
    color: var(--gray);
}
.echallan-view .echallan-view-header .echallan-view-header-l h6{
    margin: 0;
    padding-left: 6px;
}
.echallan-view.unpaid{
    border-color: rgba(235, 98, 98, 0.2);
}
.echallan-view.unpaid .echallan-view-header{
    border-bottom-color: rgba(235, 98, 98, 0.2);
}
.echallan-view.unpaid .echallan-view-header p{
    color: #EB6262;
}
.echallan-view.unpaid .echallan-view-header .echallan-view-header-l p::before{
    background-color: #EB6262;
}
.echallan-view.unpaid .red{
    color: #EB6262;
}
.echallan-view.paid{
    border-color: rgba(8, 169, 117, 0.2);
}
.echallan-view.paid .echallan-view-header{
    border-bottom-color: rgba(8, 169, 117, 0.2);
}
.echallan-view.paid .echallan-view-header p{
    color: #08A975;
}
.echallan-view.paid .echallan-view-header .echallan-view-header-l p::before{
    background-color: #08A975;
}
.echallan-view.paid .green{
    color: #08A975;
}
.echallan-view .echallan-view-body{
    padding-top: 1.5rem;
}
.echallan-view .echallan-view-body p{
    color: var(--gray);
    margin: 0;
}
.echallan-view .echallan-view-body span{
    color: var(--dark);
    font-weight: 600;
}
/* ==================================================
    25. Code Editor
================================================== */
.cm-editor{
    border: 1px solid var(--border);
    border-radius: .5rem;
    overflow: hidden;
}
iframe#webpack-dev-server-client-overlay {
    display: none !important
}`, "",{"version":3,"sources":["webpack://./src/style/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;+DA0B+D;AAE/D;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,kFAAkF;AACtF;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,+FAA+F;AACnG;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;AACA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,8BAA8B;AAClC;AACA;;;;IAII,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;AACA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,2BAA2B;AAC/B;AACA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;AACpB;AACA;;;;;;;;;IASI,oCAAoC;IACpC,8BAA8B;IAC9B,yDAAiD;IAAjD,iDAAiD;IACjD,oCAAoC;AACxC;AACA;;;;;;;;;;;;;;;;IAgBI;AACJ;AACA;;;;;;;;;;;;;;;;KAgBK;AACL;AACA;IACI,gCAAgC;AACpC;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;IACtC,UAAU;AACd;AACA;;+DAE+D;AAC/D;IACI,YAAY;IACZ,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,mDAAmD;AACvD;AACA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,qCAAqC;AACzC;AACA;IACI,cAAc;IACd,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;AACA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,8BAA8B;IAC9B,mCAAmC;IACnC,qCAAqC;IACrC,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;AAC1C;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;;;IAII,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,cAAc;IACd,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,gCAAgC;IAChC,2BAA2B;IAC3B,8BAA8B;AAClC;AACA;;;IAGI,qBAAqB;AACzB;;AAEA;;IAEI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,gDAA8U;AAClV;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,wDAAwD;IACxD,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI;AACJ;AACA;IACI,cAAc;AAClB;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,YAAY;IAChB;IACA;QACI,cAAc;QACd,eAAe;QACf,WAAW;QACX,WAAW;QACX,8BAA8B;QAC9B,WAAW;IACf;IACA;;QAEI,WAAW;IACf;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;;+DAE+D;AAC/D;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;IAC9B,UAAU;AACd;AACA;IACI,WAAW;IACX,OAAO;AACX;AACA;;;;IAII,YAAY;IACZ,YAAY;AAChB;AACA;;;IAGI,YAAY;IACZ,WAAW;AACf;AACA;;IAEI,uBAAuB;AAC3B;AACA;;;IAGI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,4CAA4C;IAC5C,2BAA2B;IAC3B,uBAAuB;IACvB,8BAA8B;IAC9B,kCAAkC;IAClC,YAAY;AAChB;AACA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,gCAAgC;AACpC;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI;QACI,OAAO;QACP,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B,+BAA+B;IACnC;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,+BAA+B;QAC/B,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,aAAa;IACjB;AACJ;AACA;;+DAE+D;AAC/D;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,yCAAyC;IACzC,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;;+DAE+D;AAC/D;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;AAChB;AACA;;+DAE+D;AAC/D;IACI,kBAAkB;IAClB,wBAAwB;IACxB,qCAAqC;AACzC;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI;QACI,cAAc;QACd,4BAA4B;IAChC;AACJ;AACA;;+DAE+D;AAC/D;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,YAAY;IACZ,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gCAAgC;IAChC,wBAAwB;AAC5B;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;QACd,eAAe;IACnB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;AACA;;+DAE+D;AAC/D;IACI,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;;IAEI,wBAAwB;IACxB,eAAe;IACf,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,SAAS;IACT,QAAQ;AACZ;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;;+DAE+D;AAC/D;IACI,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,0CAA0C;IAC1C,2CAA2C;IAC3C,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,OAAO;IAEP,8BAA8B;IAC9B,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,8BAA8B;IAC9B,8CAA8C;AAClD;AACA;IACI;QACI,aAAa;IACjB;AACJ;AACA;;+DAE+D;AAC/D;;;;;;IAMI,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,2CAA2C;IAC3C,wBAAwB;AAC5B;AACA;IACI,gCAAgC;IAChC,yCAAyC;AAC7C;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;AACA;;+DAE+D;AAC/D;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,2BAA2B;IAC3B,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,2BAA2B;IAC3B,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;IACpB,2BAA2B;AAC/B;AACA;IACI,+CAA+C;IAC/C,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,mDAAmD;IACnD,sBAAsB;AAC1B;AACA;;;IAGI,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,yCAAyC;AAC7C;AACA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;AACA;IACI,sCAAsC;AAC1C;AACA;;;IAGI,yCAAyC;AAC7C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,YAAY;IACZ,8BAA8B;IAC9B,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,SAAS;AACb;;AAEA;;;IAGI,uBAAuB;AAC3B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB;IACtB,eAAe;AACnB;AACA;;IAEI,uBAAuB;AAC3B;AACA;IACI,cAAc;AAClB;AACA;IACI,sCAAsC;IACtC,qBAAqB;AACzB;AACA;IACI,mCAAmC;IACnC,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,uCAAuC;AAC3C;AACA;;IAEI,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,gCAAgC;IAChC,gCAAgC;IAChC,mCAAmC;AACvC;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,YAAY;AAChB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;;IAEI,cAAc;AAClB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,yDAAuK;AAC3K;AACA;;+DAE+D;;AAE/D;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,qCAAqC;IACrC,uCAAuC;IACvC,iCAAiC;IACjC,2CAA2C;IAC3C,uCAAuC;IACvC,wCAAwC;IACxC,kCAAkC;IAClC,4CAA4C;IAC5C,6BAA6B;IAC7B,0CAA0C;IAC1C,oCAAoC;IACpC,8CAA8C;AAClD;AACA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,mCAAmC;IACnC,iCAAiC;IACjC,+BAA+B;IAC/B,yCAAyC;IACzC,wCAAwC;IACxC,kCAAkC;IAClC,gCAAgC;IAChC,0CAA0C;IAC1C,6BAA6B;IAC7B,oCAAoC;IACpC,kCAAkC;IAClC,4CAA4C;AAChD;AACA;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,gCAAgC;IAChC,0CAA0C;IAC1C,sCAAsC;IACtC,wCAAwC;IACxC,iCAAiC;IACjC,2CAA2C;IAC3C,6BAA6B;IAC7B,0CAA0C;IAC1C,mCAAmC;IACnC,6CAA6C;AACjD;AACA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,qCAAqC;IACrC,uCAAuC;IACvC,iCAAiC;IACjC,2CAA2C;IAC3C,uCAAuC;IACvC,wCAAwC;IACxC,kCAAkC;IAClC,4CAA4C;IAC5C,6BAA6B;IAC7B,0CAA0C;IAC1C,oCAAoC;IACpC,8CAA8C;AAClD;AACA;IACI,iCAAiC;IACjC,wBAAwB;IACxB,kCAAkC;IAClC,uCAAuC;IACvC,8BAA8B;IAC9B,wCAAwC;IACxC,uCAAuC;IACvC,wCAAwC;IACxC,+BAA+B;IAC/B,yCAAyC;IACzC,6BAA6B;IAC7B,0CAA0C;IAC1C,iCAAiC;IACjC,2CAA2C;AAC/C;AACA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,qCAAqC;IACrC,uCAAuC;IACvC,iCAAiC;IACjC,2CAA2C;IAC3C,uCAAuC;IACvC,wCAAwC;IACxC,kCAAkC;IAClC,4CAA4C;IAC5C,6BAA6B;IAC7B,0CAA0C;IAC1C,oCAAoC;IACpC,8CAA8C;AAClD;AACA;IACI,8BAA8B;IAC9B,qCAAqC;IACrC,uCAAuC;IACvC,iCAAiC;IACjC,2CAA2C;IAC3C,qCAAqC;IACrC,wCAAwC;IACxC,kCAAkC;IAClC,4CAA4C;IAC5C,6BAA6B;IAC7B,uCAAuC;IACvC,8CAA8C;AAClD;AACA;IACI,6BAA6B;IAC7B,oCAAoC;IACpC,uCAAuC;IACvC,gCAAgC;IAChC,0CAA0C;IAC1C,qCAAqC;IACrC,wCAAwC;IACxC,iCAAiC;IACjC,2CAA2C;IAC3C,6BAA6B;IAC7B,sCAAsC;IACtC,6CAA6C;AACjD;AACA;IACI,8BAA8B;IAC9B,qCAAqC;IACrC,uCAAuC;IACvC,iCAAiC;IACjC,2CAA2C;IAC3C,qCAAqC;IACrC,wCAAwC;IACxC,kCAAkC;IAClC,4CAA4C;IAC5C,6BAA6B;IAC7B,uCAAuC;IACvC,8CAA8C;AAClD;AACA;IACI,8BAA8B;IAC9B,qCAAqC;IACrC,uCAAuC;IACvC,iCAAiC;IACjC,2CAA2C;IAC3C,qCAAqC;IACrC,wCAAwC;IACxC,kCAAkC;IAClC,4CAA4C;IAC5C,6BAA6B;IAC7B,uCAAuC;IACvC,8CAA8C;AAClD;AACA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,uCAAuC;IACvC,8BAA8B;IAC9B,wCAAwC;IACxC,qCAAqC;IACrC,wCAAwC;IACxC,+BAA+B;IAC/B,yCAAyC;IACzC,6BAA6B;IAC7B,oCAAoC;IACpC,2CAA2C;AAC/C;AACA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,wBAAwB;IACxB,kCAAkC;IAClC,iCAAiC;IACjC,wCAAwC;IACxC,mCAAmC;IACnC,yCAAyC;IACzC,gCAAgC;IAChC,2CAA2C;IAC3C,yBAAyB;IACzB,uCAAuC;IACvC,qBAAqB;AACzB;AACA;IACI,wBAAwB;IACxB,kCAAkC;IAClC,wCAAwC;IACxC,2BAA2B;AAC/B;AACA;;IAEI,wCAAwC;IACxC,oCAAoC;AACxC;AACA;IACI,8BAA8B;IAC9B,mCAAmC;AACvC;AACA;;IAEI,gCAAgC;AACpC;AACA;IACI,6BAA6B;IAC7B,kCAAkC;AACtC;AACA;;IAEI,+BAA+B;AACnC;AACA;IACI,8BAA8B;IAC9B,mCAAmC;AACvC;AACA;;IAEI,gCAAgC;AACpC;AACA;IACI,6BAA6B;AACjC;AACA;;IAEI,oCAAoC;IACpC,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;AACA;;IAEI,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B,+BAA+B;IACnC;AACJ;AACA;;+DAE+D;AAC/D;IACI,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;;IAEI,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,yCAAyC;AAC7C;AACA;;+DAE+D;AAC/D;IACI,8BAA8B;IAC9B,2BAA2B;AAC/B;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,+BAA+B;AACnC;AACA;IACI,iBAAiB;AACrB;AACA;;+DAE+D;AAC/D;IACI,oDAAoD;IACpD,eAAe;IACf,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,YAAY;IACZ,oBAAoB;AACxB;AACA;;IAEI,6BAA6B;AACjC;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;GACG,eAAe;GACf,YAAY;AACf;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,yCAAyC;AAC7C;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;IAEI,0CAA0C;AAC9C;AACA;IACI;AACJ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,cAAc;IACd,qBAAqB;AACzB;AACA;;AAEA;AACA;IACI;QACI,aAAa;IACjB;AACJ;AACA;;AAEA;AACA;;+DAE+D;AAC/D;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,mCAAmC;IACnC,+BAA+B;IAC/B,8BAA8B;IAC9B,wBAAwB;IACxB,iCAAiC;IACjC,qCAAqC;IACrC,uCAAuC;IACvC,iCAAiC;IACjC,iCAAiC;IACjC,2CAA2C;IAC3C,uDAAuD;IACvD,iCAAiC;IACjC,uEAAuE;IACvE,kCAAkC;IAClC,kCAAkC;IAClC,4CAA4C;IAC5C,uCAAuC;IACvC,iCAAiC;IACjC,8CAA8C;IAC9C,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,0CAA0C;AAC9C;AACA;EACE,sBAAsB;AACxB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;;;;IAII,iBAAiB;AACrB;AACA;IACI,gCAAgC;IAChC,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;;IAEI,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;;IAEI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;;IAEI,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;+DAE+D;AAC/D;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;+DAE+D;AAC/D;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB;;;;KAIC;IACD,YAAY;IACZ,WAAW;IACX,UAAU;IACV,iCAAiC;AACrC;AACA;IACI;;;;KAIC;AACL;AACA;;;;;;;;;;;;;;;;;;;;;;;;;GAyBG;AACH;IACI,kBAAkB;IAClB,sBAAsB;IACtB,+BAA+B;AACnC;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAWA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;AACA;;+DAE+D;AAC/D;IACI,yCAAyC;IACzC,6BAA6B;IAC7B,iCAAiC;AACrC;AACA;;+DAE+D;AAC/D;;IAEI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,SAAS;IACT,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;;+DAE+D;AAC/D;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,6CAA6C;AACjD;AACA;IACI,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,iBAAiB;IACjB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;;+DAE+D;AAC/D;IACI,uBAAuB;IACvB,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,uBAAuB;IACvB,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,mCAAmC;IACnC,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,6BAA6B;AACjC;AACA;IACI,yCAAyC;IACzC,sCAAsC;IACtC,iCAAiC;IACjC,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,kCAAkC;IAClC,2BAA2B;AAC/B;AACA;IACI,oCAAoC;AACxC;AACA;;IAEI,6BAA6B;AACjC;AACA;;+DAE+D;AAC/D;IACI,yCAAyC;IACzC,6BAA6B;AACjC;AACA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;AACA;;+DAE+D;AAC/D;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,iDAAiD;IACjD,gCAAgC;AACpC;AACA;IACI,iDAAiD;IACjD,gCAAgC;AACpC;AACA;;+DAE+D;AAC/D;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;AACnB;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;IACV,yBAAyB;IACzB,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,OAAO;IACP,WAAW;IACX,WAAW;IACX,+BAA+B;AACnC;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,cAAc;AAClB;AACA;;+DAE+D;AAC/D;IACI,2BAA2B;AAC/B;AACA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;;;;IAII,+BAA+B;AACnC;AACA;;+DAE+D;AAC/D;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,SAAS;AACb;AACA;;oDAEoD;AACpD;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,UAAU;AACd;AACA;;oDAEoD;AACpD;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,aAAa;IACb,eAAe;IACf,aAAa;IACb,uEAAuE;AAC3E;AACA;;IAEI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,sCAAsC;IACtC,qBAAqB;AACzB;AACA;IACI,gCAAgC;IAChC,wBAAwB;AAC5B;AACA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;;IAEI,wBAAwB;IACxB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,sCAAsC;IACtC,kBAAkB;AACtB;AACA;;;;IAII,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;;IAEI,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;;IAEI,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,iDAAiD;AACrD;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;;oDAEoD;AACpD;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,8BAA8B;IAC9B,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,qCAAqC;IACrC,qBAAqB;AACzB;AACA;IACI,qCAAqC;IACrC,qBAAqB;AACzB;AACA;IACI,sCAAsC;IACtC,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;IACrC,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,iCAAiC;IACjC,oCAAoC;IACpC,8BAA8B;AAClC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,gCAAgC;AACpC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;AACA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;;IAEI,2BAA2B;AAC/B;AACA;IACI,QAAQ;AACZ;AACA;;oDAEoD;AACpD;IACI,+BAA+B;IAC/B,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,oBAAoB;AACxB;AACA;IACI,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,+BAA+B;AACnC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;oDAEoD;AACpD;IACI,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI;AACJ","sourcesContent":["/* *-----------------------------------------------------------------------------------\n    CSS INDEX\n    ===================\n    1. Default\n    2. Sidebar\n    3. Header\n    4. Menu Button\n    5. Footer\n    6. Main Content\n    7. Page Heading\n    8. Avatar\n    9. Card\n    10. Table\n    11. Forms\n    12. Button\n    13. Switch Button 1\n    14. Modal\n    15. Login Screen\n    16. Pagination\n    17. Page Not Found\n    18. Loader\n    19. Sweet Alert\n    20. React Switch\n    21. Darkmode\n/*--------------------------------------------------------------\n    1. Default\n--------------------------------------------------------------*/\n@import url('https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400;500;600;700&display=swap');\n* {\n    outline-color: transparent;\n    outline-style: none;\n}\n\n:root {\n    --white: #FFFFFF;\n    --light: #E6ECFF;\n    --light2: #E5F0FF;\n    --dark: #24272C;\n    --gray: #6C737D;\n    --primary: #456DFF;\n    --success: #34A853;\n    --danger: #EA4335;\n    --warning: #FFBF1C;\n    --info: #4285F4;\n    --purple: #8652ff;\n    --border: #CED8E7;\n    --border2: #CEE5FC;\n    --font-white: #FFFFFF;\n    --box-shadow: 0 0 6px -4px #00000014, 0 0 16px 0 #0000000d, 0 0 28px 8px #0000000d;\n}\n\n[data-theme=\"waitover-darks\"] {\n    --white: #201e26;\n    --light: #141218;\n    --light2: #141218;\n    --dark: #b2b2b2;\n    --gray: #b2b2b2;\n    --primary: #456DFF;\n    --success: #44CF94;\n    --danger: #EA4335;\n    --warning: #FFBF1C;\n    --info: #4285F4;\n    --purple: #8652ff;\n    --border: #2e2d32;\n    --border2: #2e2d32;\n    --font-white: #FFFFFF;\n    --box-shadow: 0 3px 6px -4px #0000006b, 0 0 16px 0 #0000002b, 0 0 28px 8px #0000004a !important;\n}\nhtml.light {\n    --white: #FFFFFF;\n    --light: #E6ECFF;\n    --light2: #E5F0FF;\n    --dark: #24272C;\n    --gray: #6C737D;\n    --primary: #456DFF;\n    --success: #34A853;\n    --danger: #EA4335;\n    --warning: #FFBF1C;\n    --info: #4285F4;\n    --purple: #8652ff;\n    --border: #EDEDED;\n    --border2: #CEE5FC;\n    --font-white: #FFFFFF;\n}\nhtml.dark {\n    --white: #201e26;\n    --light: #141218;\n    --light2: #141218;\n    --dark: #b2b2b2;\n    --gray: #b2b2b2;\n    --primary: #456DFF;\n    --success: #44CF94;\n    --danger: #EA4335;\n    --warning: #FFBF1C;\n    --info: #4285F4;\n    --purple: #8652ff;\n    --border: #2e2d32;\n    --border2: #2e2d32;\n    --font-white: #FFFFFF;\n}\nbody {\n    font-family: 'Maven Pro', sans-serif;\n    color: var(--dark);\n    font-size: 15px;\n    background-color: var(--light2);\n    overflow-x: hidden;\n    scroll-behavior: smooth;\n}\n::-webkit-scrollbar {\n    width: 6px !important;\n    height: 6px !important;\n}\n::-webkit-scrollbar-track {\n    background-color: transparent !important;\n}\n::-webkit-scrollbar-thumb {\n    background: var(--gray);\n    border-radius: .325rem;\n}\n::selection {\n    color: var(--font-white);\n    background-color: var(--primary);\n}\n::-moz-selection {\n    color: var(--font-white);\n    background-color: var(--primary);\n}\na {\n    color: var(--dark);\n    text-decoration: none;\n}\na:hover, a:focus{\n    text-decoration: none;\n}\na:hover {\n    color: var(--primary);\n}\na:-webkit-any-link:focus-visible {\n    outline-offset: 0;\n}\na:-webkit-any-link:focus-visible {\n    outline-offset: unset;\n}\nselect {\n    background-color: var(--light) !important;\n}\n.dropdown-item{\n    font-weight: 500;\n    color: var(--dark);\n}\n.dropdown-item:focus, .dropdown-item:hover {\n    color: var(--dark);\n    background-color: var(--light);\n}\nbutton:focus,\n.btn-close:focus,\n.btn:focus-visible,\n.btn:focus {\n    outline: 0;\n    box-shadow: unset;\n}\n:focus-visible {\n    outline: unset;\n}\n\n:focus-visible {\n    outline: 0;\n}\n:-webkit-direct-focus {\n    outline-color: unset;\n    outline-style: unset;\n    outline-width: 0 !important;\n}\n:focus {\n    outline-color: unset;\n    outline-style: unset;\n    outline-width: 0;\n}\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n    -webkit-text-fill-color: var(--dark);\n    background-color: var(--light);\n    transition: background-color 5000s ease-in-out 0s;\n    -webkit-box-shadow: unset !important;\n}\n.form-control::-webkit-input-placeholder,\ninput[type=text]::-webkit-input-placeholder,\ninput[type=password]::-webkit-input-placeholder,\ninput[type=datetime]::-webkit-input-placeholder,\ninput[type=datetime-local]::-webkit-input-placeholder,\ninput[type=date]::-webkit-input-placeholder,\ninput[type=month]::-webkit-input-placeholder,\ninput[type=time]::-webkit-input-placeholder,\ninput[type=week]::-webkit-input-placeholder,\ninput[type=number]::-webkit-input-placeholder,\ninput[type=email]::-webkit-input-placeholder,\ninput[type=url]::-webkit-input-placeholder,\ninput[type=search]::-webkit-input-placeholder,\ninput[type=tel]::-webkit-input-placeholder,\ninput[type=color]::-webkit-input-placeholder,\ntextarea::-webkit-input-placeholder {\n    color: #6C737D\n}\nhtml.dark .form-control::-webkit-input-placeholder,\nhtml.dark input[type=text]::-webkit-input-placeholder,\nhtml.dark input[type=password]::-webkit-input-placeholder,\nhtml.dark input[type=datetime]::-webkit-input-placeholder,\nhtml.dark input[type=datetime-local]::-webkit-input-placeholder,\nhtml.dark input[type=date]::-webkit-input-placeholder,\nhtml.dark input[type=month]::-webkit-input-placeholder,\nhtml.dark input[type=time]::-webkit-input-placeholder,\nhtml.dark input[type=week]::-webkit-input-placeholder,\nhtml.dark input[type=number]::-webkit-input-placeholder,\nhtml.dark input[type=email]::-webkit-input-placeholder,\nhtml.dark input[type=url]::-webkit-input-placeholder,\nhtml.dark input[type=search]::-webkit-input-placeholder,\nhtml.dark input[type=tel]::-webkit-input-placeholder,\nhtml.dark input[type=color]::-webkit-input-placeholder,\nhtml.dark textarea::-webkit-input-placeholder {\n     color: #444444\n}\n.text-primary{\n    color: var(--primary) !important;\n}\n.border{\n    border-color: var(--border) !important;\n}\n.border-bottom{\n    border-color: var(--border) !important;\n}\n.border-start{\n    border-color: var(--border) !important;\n}\nhr{\n    border-color: var(--border) !important;\n    opacity: 1;\n}\n/*--------------------------------------------------------------\n    2. Sidebar\n--------------------------------------------------------------*/\n.sidebar-wrapper {\n    width: 250px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 10;\n    background-color: var(--white);\n    bottom: 0;\n    transition: width 0.3s ease-out, left 0.5s ease-out;\n}\n/* SideBar Header*/\n.sidebar-wrapper .sidebar-header {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 75px;\n    border-right: 1px solid var(--border);\n}\n.sidebar-wrapper .sidebar-header img {\n    display: block;\n    max-width: 100%;\n    height: 44px;\n    margin: 0 auto;\n}\n/* SideBar Menu*/\n.sidebar-menu {\n    position: relative;\n    width: 250px;\n    height: calc(100vh - 75px);\n    background-color: var(--white);\n    border-top: 1px solid var(--border);\n    border-right: 1px solid var(--border);\n    overflow-y: auto;\n    transition: width 0.3s ease-out;\n}\n\n.sidebar-wrapper .menu {\n    margin-top: 1rem;\n    padding: 0;\n    font-weight: 600;\n}\n\n.sidebar-wrapper .menu .sidebar-link {\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding: 1rem;\n    margin: 0 1rem;\n    font-size: 15px;\n    font-weight: 500;\n    border-radius: 0.5rem;\n    transition: 0.3s;\n    text-decoration: none;\n    color: var(--gray);\n}\n\n.sidebar-wrapper .menu .sidebar-link.active i,\n.sidebar-wrapper .menu .sidebar-link.active>span {\n    color: var(--primary);\n}\n\n.sidebar-wrapper .menu .sidebar-link.active{\n    background-color: rgb(69 109 255 / 7%);\n}\n.sidebar-wrapper .menu .sidebar-link i {\n    font-size: 1.25rem;\n    color: var(--gray);\n}\n\n.sidebar-wrapper .menu .sidebar-link span {\n    margin-left: .7rem;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 15ch;\n}\n\n.sidebar-wrapper .menu .sidebar-item:hover a,\n.sidebar-wrapper .menu .sidebar-item:hover a i,\n.sidebar-wrapper .menu .sidebar-link:hover,\n.sidebar-wrapper .menu .sidebar-link:hover i {\n    color: var(--primary);\n}\n\n.sidebar-wrapper .menu .sidebar-item {\n    list-style: none;\n    position: relative;\n}\n\n.sidebar-wrapper .menu .sidebar-item.has-sub .sidebar-link {\n    cursor: pointer;\n}\n\n.sidebar-wrapper .menu .sidebar-item.has-sub .sidebar-link:after {\n    content: \"\\ea4a\";\n    font-family: boxicons !important;\n    position: absolute;\n    color: var(--gray);\n    right: 15px;\n    top: 14px;\n    display: block;\n    font-size: 20px;\n}\n.sidebar-wrapper .menu .sidebar-item.active .sidebar-link:before {\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 4px;\n    height: 30px;\n    background-color: var(--primary);\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n}\n.sidebar-wrapper .menu .sidebar-item .sidebar-link.active span,\n.sidebar-wrapper .menu .sidebar-item.has-sub.active .sidebar-link:after,\n.sidebar-wrapper .menu .sidebar-item.has-sub:hover .sidebar-link:after {\n    color: var(--primary);\n}\n\n.sidebar-wrapper .menu .sidebar-item .sidebar-link.active i,\n.sidebar-wrapper .menu .sidebar-item .sidebar-link.active svg {\n    fill: var(--primary);\n    color: var(--primary);\n}\n\n.sidebar-wrapper .menu .sidebar-item.active .sidebar-link.has-sub:after {\n    content: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" className=\"feather feather-chevron-down\"><path stroke=\"%23fff\" stroke-width=\"1\" d=\"M6 9l6 6 6-6\"/></svg>');\n}\n\n.sidebar-wrapper .menu .submenu {\n    list-style: none;\n    display: none;\n    transition: max-height 2s cubic-bezier(0, 0.55, 0.45, 1);\n    overflow: hidden;\n}\n\n.sidebar-wrapper .menu .submenu.active {\n    max-height: 999px;\n    display: block;\n}\n\n.sidebar-wrapper .menu .submenu .submenu-item.active {\n    position: relative;\n}\n\n.sidebar-wrapper .menu .submenu .submenu-item a.active {\n    color: var(--primary);\n}\n\n.sidebar-wrapper .menu .submenu .submenu-item.active>a {\n    color: var(--primary);\n}\n\n.sidebar-wrapper .menu .submenu .submenu-item a {\n    padding: 0.7rem 1.4rem;\n    padding-left: 2.1rem;\n    display: block;\n    color: var(--gray);\n    font-size: 15px;\n    font-weight: 500;\n    letter-spacing: 0.5px;\n    transition: all 0.3s;\n}\n\n.sidebar-wrapper .menu .submenu .submenu-item a:hover {\n    color: var(--primary);\n}\n.layout-wrapper .toggler {\n    display: none;\n}\n.dark .layout-wrapper .sidebar-logo .logo{\n    display: none;\n}\n.dark .layout-wrapper .sidebar-logo .logodark{\n    display: block !important;\n}\n.layout-wrapper .sidebar-logo .logo-mini{\n    display: none;\n}\n.layout-wrapper.collapsed .menu .sidebar-item.has-sub .sidebar-link:after{\n    opacity: 0 \n}\n.layout-wrapper.collapsed .sidebar-menu:hover .sidebar-item.has-sub .sidebar-link:after{\n    opacity: unset;\n}\n@media screen and (min-width: 1199px) {\n    .layout-wrapper.collapsed .sidebar-logo .logo{\n        display: none;\n    }\n    .layout-wrapper.collapsed .sidebar-logo .logo-mini{\n        display: block;\n    }\n    .layout-wrapper.collapsed .sidebar-logo .logodark{\n        display: none !important;\n    }\n    .layout-wrapper.collapsed .sidebar-menu:hover{\n        width: 250px;\n    }\n    .layout-wrapper .toggler {\n        display: block;\n        position: fixed;\n        left: 265px;\n        top: 23.5px;\n        transition: left 0.3s ease-out;\n        z-index: 99;\n    }\n    .layout-wrapper.collapsed .sidebar-wrapper,\n    .layout-wrapper.collapsed .sidebar-menu{\n        width: 85px;\n    }\n    .layout-wrapper.collapsed header.sidebar-header{\n        left: 85px;\n        width: calc(100% - 85px);\n    }\n    .layout-wrapper.collapsed .toggler{\n        left: 100px;\n    }\n    .layout-wrapper.collapsed #main {\n        margin-left: 85px;\n    }\n}\n@media screen and (max-width: 1199px) {\n    .sidebar-wrapper {\n        position: fixed;\n        left: -250px;\n    }\n    .sidebar-wrapper .sidebar-toggler.x {\n        display: block;\n    }\n    .sidebar-wrapper.active {\n        left: 0 !important;\n    }\n}\n/*--------------------------------------------------------------\n    3. Header\n--------------------------------------------------------------*/\nheader.sidebar-header {\n    background-color: var(--white);\n    display: flex !important;\n    align-items: center;\n    justify-content: space-between;\n    position: fixed;\n    left: 250px;\n    width: calc(100% - 250px);\n    height: 75px;\n    padding: 0 1.5rem;\n    transition: left 0.3s ease-out;\n    z-index: 9;\n}\nheader.sidebar-header.full-header{\n    width: 100%;\n    left: 0;\n}\n.sidebar-header .header-left-menu .logo,\n.sidebar-header .sidebar-logo .logo,\n.sidebar-header .header-left-menu .logodark,\n.sidebar-header .sidebar-logo .logodark{\n    width: 200px;\n    height: auto;\n}\n.sidebar-header .header-left-menu .logo-mini,\n.sidebar-header .header-right-menu .logo-mini,\n.sidebar-header .sidebar-logo .logo-mini{\n    height: 44px;\n    width: auto;\n}\nhtml.dark .sidebar-header .header-left-menu .logo path:first-child,\nhtml.dark .sidebar-header .sidebar-logo .logo path:first-child{\n    fill: var(--font-white);\n}\nhtml.dark .sidebar-header .header-left-menu .logo-mini path:last-child,\nhtml.dark .sidebar-header .header-right-menu .logo-mini path:last-child,\nhtml.dark .sidebar-header .sidebar-logo .logo-mini path:last-child{\n    fill: var(--font-white);\n}\nheader .header-right-menu{\n    display: flex;\n    align-items: center;\n}\nheader .header-right-menu .dropdown .dropdown-toggle {\n    display: block;\n    border: none;\n    padding: 0.5rem;\n    background-color: var(--light);\n    border-radius: 0.625rem;\n    margin: 0;\n    width: 100%;\n    box-shadow: none;\n}\nheader .header-right-menu .user-menu img{\n    width: 44px;\n    height: 44px;\n    max-width: 44px;\n    min-height: 44px;\n    border: 1px solid var(--border);\n    border-radius: .625rem;\n}\nheader .header-right-menu .dropdown .dropdown-toggle::after {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 12px;\n    border-top: 0.3em solid var(--dark);\n}\n\nheader .header-right-menu .dropdown-menu.show {\n    display: block;\n    margin: 1rem .625rem 1rem -.625rem!important;\n    min-width: 218px !important;\n    border-radius: 0.625rem;\n    background-color: var(--white);\n    box-shadow: 0 0 20px 3px #00000014;\n    border: none;\n}\nheader .header-right-menu .dropdown-item.active, header .header-right-menu .dropdown-item:active {\n    color: var(--font-white);\n    text-decoration: none;\n    background-color: var(--primary);\n}\nheader .header-right-menu .dropdown-divider {\n    border-top-color: var(--border);\n}\n\nheader .header-right-menu .dropdown .user-menu {\n    display: flex;\n    align-items: center;\n    padding-right: 24px;\n}\n\nheader .header-right-menu .dropdown .user-menu .user-name {\n    text-align: left;\n}\n\nheader .header-right-menu .dropdown .user-menu .user-name h6 {\n    color: var(--dark);\n    font-size: 15px;\n    font-weight: 600;\n    margin-bottom: 0;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 15ch;\n}\n\nheader .header-right-menu .dropdown .user-menu .user-name p {\n    color: var(--gray);\n    margin-bottom: 0;\n    font-size: 14px;\n}\n@media (max-width: 1199.98px) {\n    header.sidebar-header {\n        left: 0;\n        width: 100%;\n    }\n    header .header-right-menu .burger-btn{\n        margin-left: .25rem;\n    }\n}\n@media (max-width: 767.98px){\n    .full-header .header-right-menu .btn {\n        --bs-btn-padding-y: 0.25rem;\n        --bs-btn-padding-x: 0.5rem;\n        --bs-btn-font-size: 0.875rem;\n        --bs-btn-border-radius: 0.25rem;\n    }\n}\n@media (max-width: 575px) {\n    header.sidebar-header{\n        padding: 0 1rem;\n    }\n    header .header-right-menu .user-menu img {\n        width: 36px;\n        height: 36px;\n        max-width: 36px;\n        min-height: 36px;\n        border: 1px solid var(--border);\n        border-radius: 0.375rem;\n    }\n}\n@media (max-width: 450px) {\n    header .header-right-menu .dropdown .user-menu .user-name h6 {\n        max-width: 7ch;\n    }\n}\n@media (max-width: 350px) {\n    header .header-right-menu .dropdown .user-menu .user-name{\n        display: none;\n    }\n}\n/*--------------------------------------------------------------\n    4. Menu Button\n--------------------------------------------------------------*/\n.burger-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--white);\n    color: var(--dark) !important;\n    border: none;\n    width: 35px;\n    height: 35px;\n    font-size: 22px;\n    border-radius: .625rem;\n}\n.burger-btn.btn{\n    background-color: var(--white) !important;\n    color: var(--dark) !important; \n}\n.burger-btn.btn i {\n    color: var(--dark) !important;\n}\n/*--------------------------------------------------------------\n    5. Footer\n--------------------------------------------------------------*/\n.page-footer {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    padding: 1rem;\n    width: 100%;\n    height: auto;\n    background-color: var(--white);\n    position: fixed;\n    bottom: 0 !important;\n    right: 0 !important;\n}\n.page-footer i {\n    font-size: 18px;\n    line-height: 24px;\n    margin: 0 3px;\n}\n.page-footer a{\n    color: var(--primary);\n    font-weight: 600;\n    margin:0 3px;\n}\n/*--------------------------------------------------------------\n    6. Main Content\n--------------------------------------------------------------*/\n#main {\n    margin-left: 250px;\n    padding: 105px 30px 30px;\n    transition: margin-left 0.3s ease-out;\n}\n#main.full-page-content {\n    margin-left: 0;\n}\n.page-content .card.radiustop-0{\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n@media screen and (max-width: 1199px) {\n    #main {\n        margin-left: 0;\n        padding: 91px 16px 16px 16px;\n    }\n}\n/*--------------------------------------------------------------\n    7. Page Heading\n--------------------------------------------------------------*/\n.page-heading {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem 1.25rem;\n    height: auto;\n    background-color: var(--white);\n    border-top-left-radius: 0.625rem;\n    border-top-right-radius: 0.625rem;\n    border-bottom: 1px solid var(--border);\n}\n\n.page-heading h3 {\n    position: relative;\n    display: flex;\n    align-items: center;\n    font-size: 24px;\n    font-weight: 700;\n    color: var(--dark);\n    padding-left: 1rem;\n    margin-bottom: 0;\n}\n.page-heading h3::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 3px;\n    height: 20px;\n    background-color: var(--primary);\n}\n.page-heading h3 .btn-icon i{\n    font-size: 1.75rem !important;\n    color: var(--dark);\n}\n.page-heading.backbtn h3{\n    padding-left: 0;\n}\n.page-heading.backbtn h3::before{\n    content: unset;\n}\n.page-heading h3 span{\n    color: var(--primary);\n    margin-left: .25rem;\n}\n.page-title-headings {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 0.5rem;\n}\n\n.page-title-headings h3 {\n    margin-bottom: 0;\n    margin-right: 1rem;\n}\n.page-heading-right{\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n}\n.page-heading .breadcrumb {\n    margin: 0;\n}\n.page-heading .breadcrumb .breadcrumb-item a {\n    display: flex;\n    align-items: center;\n}\n.page-heading .breadcrumb .breadcrumb-item.active {\n    color: var(--primary);\n}\n.page-heading .page-heading-btn-group{\n    display: flex;\n    align-items: center;\n    border: 1px solid var(--primary);\n    border-radius: 50px;\n    overflow: hidden;\n}\n.page-heading .page-heading-btn-group a{\n    font-weight: 500;\n    padding: 0.547rem 1rem;\n    font-size: 15px;\n    min-width: 110px;\n    text-align: center;\n}\n.page-heading .page-heading-btn-group a.active{\n    background-color: var(--primary);\n    color: var(--font-white);\n}\n.custom-btn-add i{\n    display: none;\n}\n@media (max-width: 768.98px) {\n    .page-heading {\n        padding: 1rem;\n    }\n    .custom-btn-add i{\n        display: block;\n        font-size: 20px;\n    }\n    .custom-btn-add span{\n        display: none;\n    }\n}\n\n@media (max-width: 575.98px) {\n    .page-heading h3 {\n        font-size: 22px;\n    }\n}\n/*--------------------------------------------------------------\n    8. Avatar\n--------------------------------------------------------------*/\n.avatar {\n    display: inline-flex;\n    border-radius: 50%;\n    text-align: center;\n    vertical-align: middle;\n    position: relative;\n}\n.avatar .avatar-content {\n    width: 32px;\n    height: 32px;\n    color: var(--font-white);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 0.875rem;\n}\n.avatar .avatar-content i,\n.avatar .avatar-content svg {\n    color: var(--font-white);\n    font-size: 1rem;\n    height: 1rem;\n}\n.avatar img {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n}\n.avatar .avatar-status {\n    width: 0.7rem;\n    height: 0.7rem;\n    position: absolute;\n    border-radius: 50%;\n    border: 1px solid var(--border);\n    bottom: 0;\n    right: 0;\n}\n.avatar.avatar-sm .avatar-content,\n.avatar.avatar-sm img {\n    width: 24px;\n    height: 24px;\n    font-size: 0.8rem;\n}\n.avatar.avatar-md .avatar-content,\n.avatar.avatar-md img {\n    width: 32px;\n    height: 32px;\n    font-size: 0.8rem;\n}\n.avatar.avatar-lg .avatar-content,\n.avatar.avatar-lg img {\n    width: 48px;\n    height: 48px;\n    font-size: 1.2rem;\n}\n.avatar.avatar-xl .avatar-content,\n.avatar.avatar-xl img {\n    width: 60px;\n    height: 60px;\n    font-size: 1.4rem;\n}\n/*--------------------------------------------------------------\n    9. Card\n--------------------------------------------------------------*/\n.card {\n    border: none;\n    border-radius: .625rem;\n    background-color: var(--white);\n}\n\n.card-header {\n    border-bottom: none;\n    background-color: var(--white);\n    border-top-left-radius: .625rem !important;\n    border-top-right-radius: .625rem !important;\n    padding: 1.25rem;\n}\n.card-body {\n    padding: 1.25rem;\n}\n.card-body .row:last-child {\n    border-bottom: unset !important;\n}\n.card-image {\n    margin-bottom: .5rem;\n    overflow: hidden;\n    padding-top: 50.2%;\n    position: relative;\n    border-radius: .525rem;\n}\n.card-image img {\n    border-radius: .652rem;\n    display: block;\n    height: 100%;\n    left: 0;\n    -o-object-position: center center;\n    object-position: center center;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    margin-bottom: 0.5rem;\n}\n.card-footer {\n    padding: 1.25rem;\n    background-color: var(--white);\n    border-top-color:var(--border);\n    border-radius:  0 0 .625rem .625rem !important;\n}\n@media (max-width: 400px) {\n    .card-header, .card-body, .card-footer{\n        padding: 1rem;\n    }\n}\n/*--------------------------------------------------------------\n    10. Table\n--------------------------------------------------------------*/\ntbody,\ntd,\ntfoot,\nth,\nthead,\ntr {\n    vertical-align: middle;\n    color: var(--dark);\n}\n.table-bg-primary.table thead th{\n    background-color: var(--primary) !important;\n    color: var(--font-white);\n}\nthead th{\n    padding: .75rem .5rem !important;\n    background-color: var(--light) !important;\n}\ntbody td {\n    color: var(--gray);\n    font-weight: 500;\n}\n.table-responsive {\n    box-shadow: 0 0 0 1px var(--border2);\n    border-radius: .625rem;\n    background-color: var(--white);\n}\n\n.table-responsive table {\n    margin-bottom: 0;\n}\n\n.table-responsive .table> :not(caption)>*>* {\n    padding: .5rem;\n}\n\n.table-responsive .table-bordered> :not(caption)>* {\n    border-width: 0;\n}\n\n.table-responsive .table> :not(:last-child)> :last-child>* {\n    border-bottom-color: var(--border2);\n}\n\n.table-responsive .table th,\n.table-responsive .table td {\n    border: 1px solid var(--border2);\n}\n\n.table-responsive .table th:first-child,\n.table-responsive .table td:first-child {\n    border-left: none;\n}\n\n.table-responsive .table th:last-child,\n.table-responsive .table td:last-child {\n    border-right: none;\n}\n\n.table-responsive .table tr:first-child th {\n    border-top: none;\n}\n\n.table-responsive .table tr:last-child td {\n    border-bottom: none;\n}\n.modal-img img{\n    width: 40px;\n    height: 40px;\n    border-radius: .625rem;\n}\n.table-sort-filter {\n    display: flex;\n    align-items: center;\n}\n.table-sort-filter .table-sort {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    margin-left: .5rem;\n}\n.table-sort-filter .table-sort i {\n    font-size: 10px;\n    color: var(--dark);\n    line-height: .8;\n    cursor: pointer;\n}\n.table-sort-filter .table-sort i.active{\n    color: var(--primary);\n}\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n    --bs-table-accent-bg: var(--white);\n    color: var(--gray);\n}\n.table-striped > tbody > tr:nth-of-type(even) > * {\n    --bs-table-accent-bg: var(--light);\n    color: var(--gray);\n}\n/*--------------------------------------------------------------\n    11. Forms\n--------------------------------------------------------------*/\n.form-label {\n    font-size: 14.5px;\n    color: var(--gray);\n    font-weight: 500;\n    margin-bottom: 0;\n}\nlabel.form-label .rerq {\n    color: var(--danger);\n    margin-left: 0.1rem;\n}\nlabel.error {\n    display: none;\n    font-size: .875em;\n    color: var(--danger);\n    background-color: #ea433512;\n    border-radius: .525rem;\n    padding: 0 .5rem;\n    margin-bottom: .5rem;\n}\n.invalid-feedback strong {\n    font-size: .875em;\n    color: var(--danger);\n    background-color: #ea433512;\n    border-radius: .525rem;\n    padding: .2rem .5rem;\n    margin-bottom: .5rem;\n    font-weight: 500 !important;\n}\n.form-control-lg {\n    min-height: calc(1.7em + 1rem + 2px) !important;\n    padding: .5rem 1rem;\n    font-size: 1.25rem;\n    border-radius: .625rem;\n}\n.form-control-sm {\n    min-height: calc(1.858em + 0.5rem + 2px) !important;\n    border-radius: .325rem;\n}\n.form-control,\n.form-select,\n.rs-picker-default .rs-picker-toggle {\n    padding: 0.375rem 0.75rem;\n    min-height: 40px;\n    border-radius: .625rem;\n    color: var(--dark);\n    font-size: 15px;\n    font-weight: 500;\n    border-color: var(--border);\n    background-color: var(--white) !important;\n}\n.form-control:disabled{\n    background-color: #E5F0FF !important;\n    border-color: #CED8E7 !important;\n}\n.dark .form-control:disabled{\n    border-color: var(--border) !important;\n}\n.dark .form-control,\n.dark .form-select,\n.dark .rs-picker-default .rs-picker-toggle{\n    background-color: var(--light) !important;\n}\n.rs-picker.rs-picker-select.was-invalid .rs-picker-toggle{\n    border-color: var(--danger) !important;\n}\n.input-group-text{\n    border: none;\n    background-color: var(--light);\n    border-radius: .625rem;\n}\n.rs-picker-default .rs-picker-toggle.rs-btn {\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n.rs-picker-default .rs-picker-toggle.rs-btn .rs-picker-toggle-caret{\n    top: 10px;\n}\n\n.rs-picker-default:not(.rs-picker-disabled) .rs-btn:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-btn:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-btn-active, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle-active,\n.rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle-active,\n.rs-picker-default:not(.rs-picker-disabled) .rs-btn:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-btn:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-btn-active, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle-active{\n    border-color: #456dff80;\n}\n.rs-picker-toggle-active, .rs-picker.rs-picker-focused{\n    box-shadow: unset;\n}\n.rs-picker-has-value .rs-btn .rs-picker-toggle-value, .rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value{\n    color: var(--dark);\n}\n.rs-picker-menu{\n    background-color: var(--white);\n    border-radius: .625rem;\n    z-index: 1060;\n    padding: .5rem !important;\n}\n.rs-picker-select-menu-item{\n    color: var(--dark);\n    border-radius: .5rem;\n    font-weight: 500;\n    line-height: 1.2;\n}\n.rs-picker-select-menu-items{\n    margin-bottom: 0;\n}\n.rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input{\n    color: var(--dark);\n    background-color: var(--light);\n    border-color: var(--border);\n    border-radius: .625rem;\n    font-size: 15px;\n}\n.rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input:focus, .rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input:hover:not(:disabled),\n.rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input:focus, .rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input:hover:not(:disabled){\n    border-color: #456dff80;\n}\n.rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input:focus{\n    outline: unset;\n}\n.rs-picker-select-menu-item:hover, .rs-picker-select-menu-item:focus, .rs-picker-select-menu-item.rs-picker-select-menu-item-focus{\n    background-color: rgb(69 109 255 / 7%);\n    color: var(--primary);\n}\n.rs-picker-select-menu-items .rs-picker-menu-group:not(:first-child) {\n    border-top: 1px solid var(--border);\n    border-top: 1px solid var(--border);\n}\n.rs-picker-select-menu-items .rs-picker-menu-group-title{\n    color: var(--dark);\n    font-weight: 600;\n}\n.form-select {\n    padding: 0.375rem 2rem 0.375rem 0.75rem;\n}\n.form-control:focus,\n.form-select:focus {\n    border-color: #456dff80;\n    outline: 0;\n    box-shadow: unset;\n    color: var(--dark);\n    background-color: var(--white);\n}\nhtml.dark .form-control:disabled{\n    background-color: #ffffff0d;\n}\n.form-control::-webkit-file-upload-button {\n    height: 40px;\n    color: var(--dark);\n    background-color: var(--white);\n    border: 4px solid var(--light);\n    border-radius: .625rem;\n}\n\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n    background-color: var(--white);\n}\n\n.form-group[class*=\"has-icon-\"].has-icon-left .form-control {\n    padding-left: 3rem;\n}\n\n.form-group[class*=\"has-icon-\"].has-icon-left .form-control-icon {\n    left: 0;\n}\n\n.form-group[class*=\"has-icon-\"].has-icon-right .form-control {\n    padding-right: 3rem;\n}\n\n.form-group[class*=\"has-icon-\"].has-icon-right .form-control-icon {\n    right: 0;\n}\n\n.form-group[class*=\"has-icon-\"] .form-control:focus~.form-control-icon i,\n.form-group[class*=\"has-icon-\"] .form-control:focus~.form-control-icon svg {\n    color: var(--primary);\n}\n\n.form-group[class*=\"has-icon-\"] .form-control.form-control-xl {\n    padding-left: 3rem;\n}\n\n.form-group[class*=\"has-icon-\"] .form-control.form-control-xl~.form-control-icon i {\n    font-size: 1.6rem;\n}\n\n.form-group[class*=\"has-icon-\"] .form-control.form-control-xl~.form-control-icon i:before {\n    color: #a6a8aa;\n}\n\n.form-group[class*=\"has-icon-\"] .form-control-icon {\n    display: flex;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    padding: 0 .8rem;\n}\n\n.form-group.form-control-lg-icon[class*=\"has-icon-\"] .form-control-icon {\n    top: 15px;\n    transform: none;\n}\n\n.form-group[class*=\"has-icon-\"] .form-control-icon i,\n.form-group[class*=\"has-icon-\"] .form-control-icon svg {\n    width: 1.4rem;\n    color: var(--gray);\n    font-size: 1.4rem;\n}\n.inputgroup {\n    position: relative;\n    overflow: hidden;\n}\n.inputgroup .form-control{\n    padding-right: 2.5rem;\n}\n.inputgroup i{\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.25rem;\n    color: var(--font-white);\n    width: 44px;\n    background-color: var(--primary);\n    border-top-right-radius: .625rem;\n    border-bottom-right-radius: .625rem;\n}\n.form-check {\n    padding-left: 2em;\n}\n\n.form-check-input {\n    width: 1.4em;\n    height: 1.4em;\n    margin-top: 0;\n    background-color: var(--light);\n    border: 1px solid var(--border);\n}\n\n.form-check .form-check-input {\n    margin-left: -2em;\n}\n\nlabel.form-check-label {\n    font-size: 15px;\n    font-weight: 500;\n    color: var(--gray);\n}\n\n.form-check-input:checked {\n    background-color: var(--primary);\n    border-color: var(--primary);\n}\n.form-switch .form-check-input{\n    position: relative;\n    width: 70px;\n    height: 30px;\n    border-radius: 50px;\n    background-color: rgb(200, 200, 200);\n    border: none;\n}\n.form-switch .form-check-input:checked{\n    background-color: var(--primary);\n}\n.form-switch .form-check-input::after{\n    content: \"OFF\";\n    position: absolute;\n    right: .75rem;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--font-white);\n}\n.form-switch .form-check-input:checked::after,\n.form-switch.yes-no .form-check-input:checked::after{\n    content: unset;\n}\n.form-switch .form-check-input:checked::before{\n    content: \"ON\";\n    position: absolute;\n    left: .75rem;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--font-white);\n}\n.form-switch.yes-no .form-check-input::after{\n    content: \"NO\";\n}\n.form-switch.yes-no .form-check-input:checked::before{\n    content: \"YES\";\n}\n.form-switch .form-check-input{\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e\");\n}\n/*--------------------------------------------------------------\n    12. Button\n--------------------------------------------------------------*/\n\n.btn-primary {\n    --bs-btn-color: var(--font-white);\n    --bs-btn-bg: var(--primary);\n    --bs-btn-border-color: var(--primary);\n    --bs-btn-hover-color: var(--font-white);\n    --bs-btn-hover-bg: var(--primary);\n    --bs-btn-hover-border-color: var(--primary);\n    --bs-btn-focus-shadow-rgb: 49, 132, 253;\n    --bs-btn-active-color: var(--font-white);\n    --bs-btn-active-bg: var(--primary);\n    --bs-btn-active-border-color: var(--primary);\n    --bs-btn-active-shadow: unset;\n    --bs-btn-disabled-color: var(--font-white);\n    --bs-btn-disabled-bg: var(--primary);\n    --bs-btn-disabled-border-color: var(--primary);\n}\n.btn-light {\n    --bs-btn-color: var(--dark);\n    --bs-btn-bg: var(--light);\n    --bs-btn-border-color: var(--light);\n    --bs-btn-hover-color: var(--dark);\n    --bs-btn-hover-bg: var(--light);\n    --bs-btn-hover-border-color: var(--light);\n    --bs-btn-focus-shadow-rgb: 211, 212, 213;\n    --bs-btn-active-color: var(--dark);\n    --bs-btn-active-bg: var(--light);\n    --bs-btn-active-border-color: var(--light);\n    --bs-btn-active-shadow: unset;\n    --bs-btn-disabled-color: var(--dark);\n    --bs-btn-disabled-bg: var(--light);\n    --bs-btn-disabled-border-color: var(--light);\n}\n.btn-danger {\n    --bs-btn-color: var(--font-white);\n    --bs-btn-bg: var(--danger);\n    --bs-btn-border-color: var(--danger);\n    --bs-btn-hover-color: var(--font-white);\n    --bs-btn-hover-bg: var(--danger);\n    --bs-btn-hover-border-color: var(--danger);\n    --bs-btn-focus-shadow-rgb: 225, 83, 97;\n    --bs-btn-active-color: var(--font-white);\n    --bs-btn-active-bg: var(--danger);\n    --bs-btn-active-border-color: var(--danger);\n    --bs-btn-active-shadow: unset;\n    --bs-btn-disabled-color: var(--font-white);\n    --bs-btn-disabled-bg: var(--danger);\n    --bs-btn-disabled-border-color: var(--danger);\n}\n.btn-success {\n    --bs-btn-color: var(--font-white);\n    --bs-btn-bg: var(--success);\n    --bs-btn-border-color: var(--success);\n    --bs-btn-hover-color: var(--font-white);\n    --bs-btn-hover-bg: var(--success);\n    --bs-btn-hover-border-color: var(--success);\n    --bs-btn-focus-shadow-rgb: 49, 132, 253;\n    --bs-btn-active-color: var(--font-white);\n    --bs-btn-active-bg: var(--success);\n    --bs-btn-active-border-color: var(--success);\n    --bs-btn-active-shadow: unset;\n    --bs-btn-disabled-color: var(--font-white);\n    --bs-btn-disabled-bg: var(--success);\n    --bs-btn-disabled-border-color: var(--success);\n}\n.btn-info {\n    --bs-btn-color: var(--font-white);\n    --bs-btn-bg: var(--info);\n    --bs-btn-border-color: var(--info);\n    --bs-btn-hover-color: var(--font-white);\n    --bs-btn-hover-bg: var(--info);\n    --bs-btn-hover-border-color: var(--info);\n    --bs-btn-focus-shadow-rgb: 49, 132, 253;\n    --bs-btn-active-color: var(--font-white);\n    --bs-btn-active-bg: var(--info);\n    --bs-btn-active-border-color: var(--info);\n    --bs-btn-active-shadow: unset;\n    --bs-btn-disabled-color: var(--font-white);\n    --bs-btn-disabled-bg: var(--info);\n    --bs-btn-disabled-border-color: var(--info);\n}\n.btn-warning {\n    --bs-btn-color: var(--font-white);\n    --bs-btn-bg: var(--warning);\n    --bs-btn-border-color: var(--warning);\n    --bs-btn-hover-color: var(--font-white);\n    --bs-btn-hover-bg: var(--warning);\n    --bs-btn-hover-border-color: var(--warning);\n    --bs-btn-focus-shadow-rgb: 49, 132, 253;\n    --bs-btn-active-color: var(--font-white);\n    --bs-btn-active-bg: var(--warning);\n    --bs-btn-active-border-color: var(--warning);\n    --bs-btn-active-shadow: unset;\n    --bs-btn-disabled-color: var(--font-white);\n    --bs-btn-disabled-bg: var(--warning);\n    --bs-btn-disabled-border-color: var(--warning);\n}\n.btn-outline-primary {\n    --bs-btn-color: var(--primary);\n    --bs-btn-border-color: var(--primary);\n    --bs-btn-hover-color: var(--font-white);\n    --bs-btn-hover-bg: var(--primary);\n    --bs-btn-hover-border-color: var(--primary);\n    --bs-btn-focus-shadow-rgb: 13,202,240;\n    --bs-btn-active-color: var(--font-white);\n    --bs-btn-active-bg: var(--primary);\n    --bs-btn-active-border-color: var(--primary);\n    --bs-btn-active-shadow: unset;\n    --bs-btn-disabled-color: var(--primary);\n    --bs-btn-disabled-border-color: var(--primary);\n}\n.btn-outline-danger {\n    --bs-btn-color: var(--danger);\n    --bs-btn-border-color: var(--danger);\n    --bs-btn-hover-color: var(--font-white);\n    --bs-btn-hover-bg: var(--danger);\n    --bs-btn-hover-border-color: var(--danger);\n    --bs-btn-focus-shadow-rgb: 13,202,240;\n    --bs-btn-active-color: var(--font-white);\n    --bs-btn-active-bg: var(--danger);\n    --bs-btn-active-border-color: var(--danger);\n    --bs-btn-active-shadow: unset;\n    --bs-btn-disabled-color: var(--danger);\n    --bs-btn-disabled-border-color: var(--danger);\n}\n.btn-outline-success {\n    --bs-btn-color: var(--success);\n    --bs-btn-border-color: var(--success);\n    --bs-btn-hover-color: var(--font-white);\n    --bs-btn-hover-bg: var(--success);\n    --bs-btn-hover-border-color: var(--success);\n    --bs-btn-focus-shadow-rgb: 13,202,240;\n    --bs-btn-active-color: var(--font-white);\n    --bs-btn-active-bg: var(--success);\n    --bs-btn-active-border-color: var(--success);\n    --bs-btn-active-shadow: unset;\n    --bs-btn-disabled-color: var(--success);\n    --bs-btn-disabled-border-color: var(--success);\n}\n.btn-outline-warning {\n    --bs-btn-color: var(--warning);\n    --bs-btn-border-color: var(--warning);\n    --bs-btn-hover-color: var(--font-white);\n    --bs-btn-hover-bg: var(--warning);\n    --bs-btn-hover-border-color: var(--warning);\n    --bs-btn-focus-shadow-rgb: 13,202,240;\n    --bs-btn-active-color: var(--font-white);\n    --bs-btn-active-bg: var(--warning);\n    --bs-btn-active-border-color: var(--warning);\n    --bs-btn-active-shadow: unset;\n    --bs-btn-disabled-color: var(--warning);\n    --bs-btn-disabled-border-color: var(--warning);\n}\n.btn-outline-info {\n    --bs-btn-color: var(--info);\n    --bs-btn-border-color: var(--info);\n    --bs-btn-hover-color: var(--font-white);\n    --bs-btn-hover-bg: var(--info);\n    --bs-btn-hover-border-color: var(--info);\n    --bs-btn-focus-shadow-rgb: 13,202,240;\n    --bs-btn-active-color: var(--font-white);\n    --bs-btn-active-bg: var(--info);\n    --bs-btn-active-border-color: var(--info);\n    --bs-btn-active-shadow: unset;\n    --bs-btn-disabled-color: var(--info);\n    --bs-btn-disabled-border-color: var(--info);\n}\n.btn-link {\n    --bs-btn-font-weight: 400;\n    --bs-btn-color: var(--primary);\n    --bs-btn-bg: transparent;\n    --bs-btn-border-color: transparent;\n    --bs-btn-hover-color:var(--white);\n    --bs-btn-hover-border-color: transparent;\n    --bs-btn-active-color: var(--white);\n    --bs-btn-active-border-color: transparent;\n    --bs-btn-disabled-color: #6c757d;\n    --bs-btn-disabled-border-color: transparent;\n    --bs-btn-box-shadow: none;\n    --bs-btn-focus-shadow-rgb: 49, 132, 253;\n    text-decoration: none;\n}\n.btn-transparent{\n    --bs-btn-bg: transparent;\n    --bs-btn-border-color: transparent;\n    --bs-btn-hover-border-color: transparent;\n    border-radius: 0 !important; \n}\n.btn-transparent:hover,\n.btn-transparent:active{\n    background-color: transparent !important;\n    border-color: transparent !important;\n}\n.btn-transparent.btn-primary{\n    --bs-btn-color: var(--primary);\n    --bs-btn-hover-color:var(--primary);\n}\n.btn-transparent.btn-primary:hover,\n.btn-transparent.btn-primary:active{\n    color: var(--primary) !important;\n}\n.btn-transparent.btn-danger{\n    --bs-btn-color: var(--danger);\n    --bs-btn-hover-color:var(--danger);\n}\n.btn-transparent.btn-danger:hover,\n.btn-transparent.btn-danger:active{\n    color: var(--danger) !important;\n}\n.btn-transparent.btn-success{\n    --bs-btn-color: var(--success);\n    --bs-btn-hover-color:var(--success);\n}\n.btn-transparent.btn-success:hover,\n.btn-transparent.btn-success:active{\n    color: var(--success) !important;\n}\n.btn-transparent i{\n    font-size: 1.25rem !important;\n}\n.btn-group-lg>.btn,\n.btn-lg {\n    padding: 0.625rem 1.25rem !important;\n    font-size: 1.25rem;\n    border-radius: .625rem;\n}\n\n.btn-sm {\n    padding: 0.407rem 0.5rem !important;\n    font-size: 0.875rem;\n    border-radius: .325rem;\n}\n\n.btn {\n    font-weight: 500;\n    border-radius: 0.625rem;\n    padding: 0.485rem 1rem;\n    font-size: 15px;\n    box-shadow: unset;\n}\n\n.btn.btn-icon-text {\n    display: flex;\n    align-items: center;\n}\n\n.btn.btn-icon-text i {\n    margin-right: .5rem;\n    font-size: 1.225rem;\n    line-height: 1.225rem;\n}\n\n.btn.btn-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.5rem;\n    height: 32px;\n    width: 32px;\n}\n\n.btn.btn-icon i {\n    font-size: 1rem;\n    line-height: 1rem;\n}\n\n.btn.btn-icon-lg {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.5rem;\n    height: 40px;\n    width: 40px;\n}\n.btn.btn-icon-lg i,\n.btn.btn-icon-lg.bx{\n    font-size: 1.15rem;\n    line-height: 1.15rem;\n}\n@media (max-width: 767.98px) {\n    .btn-group .btn {\n        --bs-btn-padding-y: 0.25rem;\n        --bs-btn-padding-x: 0.5rem;\n        --bs-btn-font-size: 0.875rem;\n        --bs-btn-border-radius: 0.25rem;\n    }\n}\n/*--------------------------------------------------------------\n    13. Switch Button 1\n--------------------------------------------------------------*/\n.switch.btn-sm {\n    min-height: 36px !important;\n}\n\n.switch-on.btn.btn-sm {\n    padding-right: 1.5rem !important;\n    line-height: 22px;\n}\n\n.switch-off.btn.btn-sm {\n    padding-left: 1.5rem !important;\n    line-height: 22px;\n}\n\n.switch.btn.btn-light,\n.switch.btn.btn-outline-light {\n    border-color: var(--border) !important;\n}\n\n.switch-on.btn {\n    padding-right: 2rem;\n    line-height: 18px;\n}\n\n.switch-off.btn {\n    padding-left: 2rem;\n    line-height: 18px;\n}\n.switch-handle{\n    background-color: var(--white) !important;\n}\n/*--------------------------------------------------------------\n    14. Modal\n--------------------------------------------------------------*/\n.modal-content{\n    background-color: var(--white);\n    border-color: var(--border);\n}\n.modal-header{\n    border-bottom-color: var(--border);\n}\n.modal .modal-header .modal-title{\n    position: relative;\n    font-size: 20px;\n    font-weight: 600;\n    padding-left: 1rem;\n}\n.modal .modal-header .modal-title::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 3px;\n    height: 20px;\n    background-color: var(--primary);\n}\n.modal .modal-body .modal-content{\n    border-color: transparent;\n}\n.modal .modal-footer{\n    border-top-color: var(--border);\n}\nhtml.dark .btn-close{\n    filter: invert(1);\n}\n/*--------------------------------------------------------------\n    15. Login Screen\n--------------------------------------------------------------*/\n.auth-box-bg{\n    /* background: url(../../public/logo/loginbg.png); */\n    max-width: 100%;\n    background-position: bottom;\n    background-repeat: no-repeat;\n}\n.auth {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    height: 100vh;\n}\n.auth .auth-box {\n    width: 500px;\n    margin: 0 auto 150px;\n}\n.auth .auth-box .card,\n.auth .auth-box .card-header{\n    background-color: transparent;\n}\n.auth .auth-box .card-header{\n    padding: 0;\n}\n.auth .auth-box .card-header .auth-logo{\n    text-align: center;\n    margin-bottom: 2.5rem;\n}\n.auth .auth-box .card-header .auth-logo .logo-mini{\n   max-width: 100%;\n   height: 60px;\n}\nhtml.dark .auth .auth-box .card-header .auth-logo .logo-mini path:last-child{\n    fill: var(--font-white);\n}\n.auth .auth-box .card-body{\n    padding: 2rem;\n    background-color: var(--white);\n    border-radius: 0.825rem;\n    box-shadow: 0 12px 34px 0 rgb(0 0 0 / 6%);\n}\n.auth .auth-box .card-body .auth-title {\n    font-size: 28px;\n    font-weight: 700;\n    margin-bottom: .75rem;\n    text-align: center;\n}\n.auth .auth-box .card-body .auth-subtitle {\n    font-size: 16px;\n    color: var(--gray);\n    margin-bottom: 2rem;\n    text-align: center;\n}\n.auth .auth-box .card-body .form-control,\n.auth .auth-box .card-body .form-check-input{\n    background-color: var(--light2) !important;\n}\n.auth .auth-box .card-body .form-check-input:checked{\n    background-color: var(--primary) !important\n}\n.auth .auth-box .input-prefix{\n    position: relative;\n}\n.auth .auth-box .input-prefix .form-control{\n    padding-left: 2.75rem;\n}\n.auth .auth-box .input-prefix.input-prefix-right .form-control{\n    padding-right: 2.75rem;\n}\n.auth .auth-box .input-prefix i {\n    position: absolute;\n    left: 0.25rem;\n    bottom: 0;\n    font-size: 20px;\n    width: 44px;\n    height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: var(--gray);\n}\n.auth .auth-box .input-prefix.input-prefix-right .icon-prefix-right{\n    left: unset;\n    right: 0.25rem;\n    color: var(--primary);\n}\n@media (max-width: 767px) {\n\n}\n@media (max-width: 400px) {\n    .auth .auth-box .card-body{\n        padding: 1rem;\n    }\n}\n@media (max-width:375px) {\n\n}\n/*--------------------------------------------------------------\n    16. Pagination\n--------------------------------------------------------------*/\n.pagination{\n    --bs-pagination-color:#c0c3c7;\n    --bs-pagination-padding-x: 0.75rem;\n    --bs-pagination-padding-y: 0.375rem;\n    --bs-pagination-font-size: 1rem;\n    --bs-pagination-color: #c0c3c7;\n    --bs-pagination-bg: #fff;\n    --bs-pagination-border-width: 1px;\n    --bs-pagination-border-color: #dee2e6;\n    --bs-pagination-border-radius: 0.375rem;\n    --bs-pagination-hover-color: #000;\n    --bs-pagination-hover-bg: #e9ecef;\n    --bs-pagination-hover-border-color: #dee2e6;\n    --bs-pagination-focus-color: var(--bs-link-hover-color);\n    --bs-pagination-focus-bg: #e9ecef;\n    --bs-pagination-focus-box-shadow: 0 0 0 0.25remrgba(13, 110, 253, 0.25);\n    --bs-pagination-active-color: #fff;\n    --bs-pagination-active-bg: #0d6efd;\n    --bs-pagination-active-border-color: #0d6efd;\n    --bs-pagination-disabled-color: #6c757d;\n    --bs-pagination-disabled-bg: #fff;\n    --bs-pagination-disabled-border-color: #dee2e6;\n    display: flex;\n    padding-left: 0;\n    list-style: none;\n}\n.page-item:nth-child(2) .page-link{\n    background-color:var(--primary) !important;\n}\n.page-item:nth-child(2) .page-link:hover{\n  color: #fff !important;\n}\n.pagination-custom{\n    margin-top: 1.5rem;\n}\n.rc-pagination {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n.rc-pagination-item{\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    justify-content: center;\n    min-width: 40px;\n    height: 40px;\n    color: var(--gray);\n    font-weight: 500;\n    border-radius: 50px;\n}\n.rc-pagination-prev:before,\n.rc-pagination-next:before{\n    font-family: 'boxicons' !important;\n    position: absolute;\n    cursor: pointer;\n    font-size: 22px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    background-color: var(--white);\n    border-radius: 50px;\n}\n.rc-pagination-next:before{\n    content: \"\\ea50\";\n}\n.rc-pagination-prev:before{\n    content: \"\\ea4d\";\n}\n.rc-pagination-item,\n.rc-pagination-prev,\n.rc-pagination-jump-prev,\n.rc-pagination-jump-next {\n    margin-right: 8px;\n}\n.rc-pagination-item.rc-pagination-item-active{\n    background-color: var(--primary);\n    color: var(--font-white);\n}\n.rc-pagination-item.rc-pagination-item-active a{\n    color: var(--font-white);\n}\n.rc-pagination-prev.rc-pagination-disabled,\n.rc-pagination-next.rc-pagination-disabled{\n    color: var(--gray);\n    opacity: 0.75;\n}\n.paggination-btn{\n    min-width: 40px;\n    height: 40px;\n    overflow: hidden;\n    background-color: transparent;\n    color: var(--gray);\n    border-radius: .625rem;\n    border: transparent;\n}\n.rc-pagination-jump-prev button,\n.rc-pagination-jump-next button {\n    border-color: transparent;\n    background-color: transparent;\n}\n\n.rc-pagination-jump-next button:after,\n.rc-pagination-jump-prev button:after {\n    display: block;\n    content: \"•••\";\n    font-size: 14px;\n    color: var(--gray);\n}\n.rc-pagination-prev, .rc-pagination-next, .rc-pagination-item, .rc-pagination-jump-prev, .rc-pagination-jump-next {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 40px;\n    height: 40px;\n    color: var(--gray);\n}\n\n/*--------------------------------------------------------------\n    17. Page Not Found\n--------------------------------------------------------------*/\n.error{\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.no-found{\n    text-align: center;\n    padding: 3rem 0;\n}\n.no-found img{\n    height: 200px;\n}\n.no-found p{\n    font-size: 20px;\n    font-weight: 600;\n    margin-top: 2rem;\n    margin-bottom: 0;\n}\n.Image-Map{\n    width: 40px;\n    height: 40px;\n}\n\n/*--------------------------------------------------------------\n    18. Loader\n--------------------------------------------------------------*/\n.loader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    overflow: hidden;\n    background-color:var(--white);\n    z-index: 999;\n}\n.loader::before {\n    content: \"\";\n    position: absolute;\n    background: linear-gradient(90deg,\n      rgba(245, 245, 245, 0) 0%,\n      rgba(245, 245, 245, 0.75) 50%,\n      rgba(245, 245, 245, 0) 100%\n    );\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    animation: skeleton 1.5s infinite;\n}\n.dark .loader::before {\n    background: linear-gradient(90deg,\n      rgba(20, 18, 24, 0) 0%,\n      rgba(20, 18, 24, 0.5) 50%,\n      rgba(20, 18, 24, 0) 100%\n    );\n}\n/* .loader:after {\n    content: \"\";\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-image: url('../public/logo/mini-logo.svg');\n    background-size: contain;\n    background-position: center center;\n    background-repeat: no-repeat;\n    width: 40px;\n    height: 40px;\n}\n.loader:before{\n    content: \"\";\n    position: fixed;\n    top: calc(50% - 40px);\n    left: calc(50% - 40px);\n    border: 2px solid var(--primary);\n    border-top-color: transparent;\n    border-radius: 50%;\n    width: 80px;\n    height: 80px;\n    -webkit-animation: animate-preloader 1s linear infinite;\n    animation: animate-preloader 1s linear infinite;\n} */\n.loader.table-loader{\n    position: absolute;\n    border-radius: .625rem;\n    min-height: calc(100vh - 227px);\n}\n.loader.table-loader:after,\n.loader.table-loader:before{\n    position: absolute;\n}\n@keyframes skeleton {\n    0% {\n        transform: translateX(-100%);\n    }\n    100% {\n        transform: translateX(100%);\n    }\n}\n@-webkit-keyframes animate-preloader {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes animate-preloader {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n/*--------------------------------------------------------------\n    19. Sweet Alert\n--------------------------------------------------------------*/\n.swal2-popup{\n    background-color: var(--white) !important;\n    color: var(--dark) !important;\n    border-radius: .625rem !important;\n}\n/*--------------------------------------------------------------\n    20. React Switch\n--------------------------------------------------------------*/\n.react-switch .react-switch-off,\n.react-switch .react-switch-on{\n    display: flex;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 30px;\n    color: var(--font-white);\n}\n.react-switch .react-switch-off{\n    margin-right: 4px;\n}\n.react-switch .react-switch-on{\n    margin-left: 4px;\n}\n.react-switch.react-switch-small .react-switch-handle{\n    box-shadow: unset !important;\n    top: 3px !important;\n    left: 2px;\n    width: 18px !important;\n    height: 18px !important;\n}\n/*--------------------------------------------------------------\n    21. Darkmode\n--------------------------------------------------------------*/\n.darkmode-switch{\n    position: relative;\n    width: 40px;\n    height: 40px;\n    margin-right: 1.5rem;\n    transition: background-color 0.3s ease-in-out;\n}\n.darkmode-switch #darkMode{\n    border: none;\n    background: transparent;\n}\n.darkmode-switch #darkMode::before{\n    content: \"\\ee4e\";\n    font-family: boxicons!important;\n    position:absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: var(--gray);\n    font-size:1.35rem;\n}  \n.darkmode-switch #darkMode.clicked::before {\n    content: \"\\eebe\";\n}\n/*--------------------------------------------------------------\n    24. Multi Select Picker\n--------------------------------------------------------------*/\n.customMulSelect .react-select__control{\n    padding: 0.1rem 0.25rem;\n    min-height: 40px;\n    border-radius: 0.625rem !important;\n    color: var(--dark);\n    font-weight: 500;\n    background-color: var(--light) !important;\n    border: none !important;\n    box-shadow: unset !important;\n}\n.customMulSelect .react-select__control .react-select__indicator.react-select__dropdown-indicator svg{\n    width: 16px;\n    transition: transform 0.2s ease-out;\n    color: hsl(0, 0%, 40%);\n}\n.customMulSelect .react-select__control.react-select__control--menu-is-open .react-select__indicator.react-select__dropdown-indicator svg{\n    transform: rotate(180deg);\n}\n.react-select__indicator-separator{\n    background-color: var(--border) !important;\n}\n.react-select__multi-value{\n    background-color: var(--white) !important;\n}\n.react-select__multi-value__label{\n    color: var(--dark) !important;\n}\n.react-select__menu{\n    background-color: var(--white) !important;\n    border-color: var(--border) !important;\n    border-radius: .625rem !important;\n    z-index: 9 !important;\n}\n.react-select__option{\n    color: var(--dark);\n    white-space: nowrap !important;\n    text-overflow: ellipsis !important;\n    overflow: hidden !important;\n}\n.customMulSelect.rs-novalidated .react-select__control{\n    border: 1px solid #dc3545 !important;\n}\n.react-select__input-container,\n.react-select__single-value{\n    color: var(--dark) !important;\n}\n/*--------------------------------------------------------------\n    22. Toastify toast\n--------------------------------------------------------------*/\n.Toastify__toast-theme--light{\n    background-color: var(--white) !important;\n    color: var(--dark) !important;\n}\n.Toastify__close-button--light{\n    color: var(--dark) !important;\n    opacity: 1 !important;\n}\n/*--------------------------------------------------------------\n    22. RS Dropdown\n--------------------------------------------------------------*/\n.rs-dropdown-menu{\n    background-color: var(--white);\n    border-radius: .625rem;\n    padding: .5rem !important;\n    z-index: 1060 !important;\n}\n.rs-dropdown-menu .rs-dropdown-item{\n    font-size: 15px;\n    color: var(--dark);\n    font-weight: 500;\n    border-radius: .5rem;\n}\n.rs-dropdown-menu .rs-dropdown-item:hover{\n    background-color: rgb(69 109 255 / 7%) !important;\n    color: var(--primary) !important;\n}\n.rs-dropdown-item:focus-visible, .rs-dropdown-item.rs-dropdown-item-focus{\n    background-color: rgb(69 109 255 / 7%) !important;\n    color: var(--primary) !important;\n}\n/*--------------------------------------------------------------\n    23. Dashboard\n--------------------------------------------------------------*/\n.vv-dashboard .card{\n    margin-bottom: 1.5rem;\n}\n.vv-dashboard .card .card-body .counter{\n    display: flex;\n}\n.vv-dashboard .card .card-body .counter .counter-media{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 50px;\n    height: 50px;\n    background-color: var(--light);\n    border-radius: .625rem;\n    font-size: 24px;\n}\n.vv-dashboard .card .card-body .counter.orange .counter-media{\n    background-color: #ffb05c33;\n    color: #FFB15C;\n}\n.vv-dashboard .card .card-body .counter.pink .counter-media{\n    background-color: #db73ff33;\n    color: #DB73FF;\n}\n.vv-dashboard .card .card-body .counter.green .counter-media{\n    background-color: #1fd9a333;\n    color: #1FD9A3;\n}\n.vv-dashboard .card .card-body .counter.blue .counter-media{\n    background-color: #6a9bf433;\n    color: #6A9BF4;\n}\n.vv-dashboard .card .card-body .counter .counter-content{\n    margin-left: 1.25rem;\n}\n.vv-dashboard .card .card-body .counter .counter-content h3{\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: .15rem;\n}\n.vv-dashboard .card .card-body .counter .counter-content p{\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--gray);\n    margin-bottom: 0;\n}\n.vv-dashboard .card .card-body .chart-title{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n}\n.vv-dashboard .card .card-body .chart-title h4{\n    font-size: 18px;\n    font-weight: 700;\n    margin: 0;\n}\n.vv-dashboard .card .card-body .attch-link .attch-link-title {\n    display: flex;\n    align-items: center;\n}\n.vv-dashboard .card .card-body .attch-link .attch-link-title i {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    font-size: 20px;\n}\n.vv-dashboard .card .card-body .attch-link.green .attch-link-title i, \n.vv-dashboard .card .card-body .attch-link.green .attch-link-content ul li a:hover {\n    color: #1FD9A3;\n}\n.vv-dashboard .card .card-body .attch-link.red .attch-link-title i, \n.vv-dashboard .card .card-body .attch-link.red .attch-link-content ul li a:hover {\n    color: #FF5C84;\n}\n.vv-dashboard .card .card-body .attch-link .attch-link-title h4 {\n    font-size: 18px;\n    font-weight: 700;\n    margin-left: 0.75rem;\n    margin-bottom: 0;\n}\n.vv-dashboard .card .card-body .attch-link .attch-link-content ul {\n    position: relative;\n    list-style: none;\n    padding-left: 0;\n    margin-bottom: 0;\n    margin-left: 12px;\n}\n.vv-dashboard .card .card-body .attch-link .attch-link-content ul:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 1px;\n    height: calc(100% - 12px);\n    background-color: var(--border);\n}\n.vv-dashboard .card .card-body .attch-link .attch-link-content ul li {\n    position: relative;\n    padding-left: 24px;\n    margin: 0.5rem 0;\n}\n.vv-dashboard .card .card-body .attch-link .attch-link-content ul li:before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 0;\n    width: 15px;\n    height: 1px;\n    background-color: var(--border);\n}\n.vv-dashboard .card .card-body .attch-link .attch-link-content ul li a {\n    font-weight: 500;\n    color: var(--font-gray);\n    transition: .3s ease;\n}\n.vv-dashboard .card .card-body .attch-link.green .attch-link-title i, \n.vv-dashboard .card .card-body .attch-link.green .attch-link-content ul li a:hover {\n    color: #1FD9A3;\n}\n.vv-dashboard .card .card-body .attch-link.red .attch-link-title i,\n.vv-dashboard .card .card-body .attch-link.red .attch-link-content ul li a:hover {\n    color: #FF5C84;\n}\n/*--------------------------------------------------------------\n    25. Popover\n--------------------------------------------------------------*/\n.popover{\n    border-color: var(--border);\n}\n.popover-body{\n    background-color: var(--white);\n    color: var(--dark);\n}\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after, .bs-popover-top>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after, .bs-popover-left>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after, .bs-popover-right>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after, .bs-popover-bottom>.popover-arrow::after{\n    border-top-color: var(--border);\n}\n/*--------------------------------------------------------------\n    25. Project Grid List\n--------------------------------------------------------------*/\n.project-grid-list .card{\n    margin-bottom: 1.5rem;\n}\n.project-grid-list .project-list-item {\n    display: flex;\n    align-items: center;\n}\n.project-grid-list .project-list-item:hover{\n    color: unset;\n}\n.project-grid-list .project-list-item img{\n    width: 50px;\n    height: 50px;\n    border-radius: .625rem;\n    margin-right: 1rem;\n}\n.project-grid-list .project-list-item .project-list-content h6{\n    font-size: 17px;\n    font-weight: 600;\n    margin-bottom: 0.25rem;\n}\n.project-grid-list .project-list-item .project-list-content p{\n    margin: 0;\n}\n/* ==================================================\n    25. User Details Modal\n================================================== */\n.user-details-modal .modal-body .user-details {\n    float: left;\n    width: 100%;\n}\n.user-details-modal .modal-body .user-details p {\n    position: relative;\n    float: left;\n    min-width: 30%;\n    font-weight: 600;\n}\n.user-details-modal .modal-body .user-details p:after {\n    content: \":\";\n    position: absolute;\n    top: 0;\n    right: 15px;\n    color: var(--dark);\n}\n.user-details-modal .modal-body .user-details span {\n    float: left;\n    width: 70%;\n}\n/* ==================================================\n    25. Date Range Picker\n================================================== */\n.daterangepicker {\n    border-radius: .5rem;\n    font-family: inherit;\n    background-color: var(--white);\n    border: unset;\n    font-size: 16px;\n    margin-top: 0;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12), 0 0 10px rgba(0, 0, 0, 0.06);\n}\n.daterangepicker.opensright:before,\n.daterangepicker.opensright:after{\n    content: unset;\n}\n.daterangepicker .ranges ul{\n    padding: .5rem;\n}\n.daterangepicker .ranges li{\n    font-size: 14px;\n    line-height: normal;\n    font-weight: 500;\n    color: var(--dark);\n    border-radius: .5rem;\n}\n.daterangepicker.show-ranges.ltr .drp-calendar.left{\n    border-left-color: var(--border);\n}\n.daterangepicker .ranges li:hover {\n    background-color: rgb(69 109 255 / 7%);\n    color: var(--primary);\n}\n.daterangepicker .ranges li.active {\n    background-color: var(--primary);\n    color: var(--font-white);\n}\n.daterangepicker .calendar-table {\n    background-color: var(--white);\n    border-color: transparent;\n}\n\n.daterangepicker .calendar-table .next span,\n.daterangepicker .calendar-table .prev span {\n    color: var(--font-white);\n    border-color: var(--dark);\n}\n.daterangepicker .drp-buttons .btn{\n    font-size: 13px;\n    padding: 0.407rem 0.75rem !important;\n}\n.daterangepicker .drp-buttons .btn.btn-default{\n    color: var(--dark);\n    background-color: var(--light);\n}\n.daterangepicker td.in-range{\n    background-color: rgb(69 109 255 / 7%);\n    color: var(--dark);\n}\n.daterangepicker td.off,\n.daterangepicker td.off.in-range,\n.daterangepicker td.off.start-date,\n.daterangepicker td.off.end-date {\n    background-color: var(--white);\n    color: var(--gray);\n}\n\n.daterangepicker td.active,\n.daterangepicker td.active:hover {\n    background-color: var(--primary);\n    color: var(--font-white);\n}\n\n.daterangepicker .drp-buttons {\n    border-color: var(--border);\n}\n.daterangepicker .drp-selected{\n    font-size: 13px;\n    font-weight: 500;\n}\n.daterangepicker td.available:hover,\n.daterangepicker th.available:hover {\n    color: var(--dark);\n    background-color: var(--light);\n}\n.daterangepicker .calendar-table th{\n    border-radius: 0;\n}\n.daterangepicker .calendar-table th,\n.daterangepicker .calendar-table td{\n    min-width: 32px;\n    width: 32px;\n    height: 32px;\n    line-height: 0;\n}\n.daterangepicker .calendar-table td{\n    font-size: 13px;\n    font-weight: 500;\n}\n.daterangepicker td.start-date.end-date {\n    border-radius: .525rem;\n}\n.daterangepicker td.start-date {\n    border-radius: .525rem 0 0 .525rem;\n}\n.daterangepicker td.end-date {\n    border-radius: 0 .525rem .525rem 0;\n}\n.daterangepicker:after{\n    border-bottom: 6px solid var(--border) !important;\n}\n.daterangepicker:before {\n    border-bottom: 7px solid var(--border);\n}\n.daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect, .daterangepicker select.ampmselect{\n    background-color: var(--white);\n    border-color: var(--border);\n    border-radius: 0.325rem;\n    color: var(--dark);\n}\n\n/* ==================================================\n    25. Dashboard\n================================================== */\n.vi-dashboard .countdata{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: var(--light);\n    border: 1px solid var(--border);\n    border-radius: 1rem;\n    padding: 1.25rem;\n}\n.vi-dashboard .countdata.blue{\n    background-color: rgb(0 143 251 / 3%);\n    border-color: #008FFB;   \n}\n.vi-dashboard .countdata.red{\n    background-color: rgb(255 69 96 / 3%);\n    border-color: #FF4560;   \n}\n.vi-dashboard .countdata.purple{\n    background-color: rgb(119 93 208 / 3%);\n    border-color: #775DD0;   \n}\n.vi-dashboard .countdata .countdata-content p{\n    font-size: 1rem;\n    font-weight: 500;\n    color: var(--dark);\n    margin-bottom: .25rem;\n    text-transform: uppercase;\n}\n.vi-dashboard .countdata .countdata-content h3{\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #2E96FF;\n    margin-bottom: 1rem;\n}\n.vi-dashboard .countdata .countdata-content ul{\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n}\n.vi-dashboard .countdata .countdata-content ul li{\n    display: flex;\n    align-items: center;\n    margin-right: .5rem;\n    border-right: 1px solid var(--border);\n    padding-right: .5rem;\n}\n.vi-dashboard .countdata .countdata-content ul li:last-child{\n    border-right: none;\n    margin: 0;\n    padding: 0;\n}\n.vi-dashboard .countdata .countdata-content ul li p{\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    line-height: normal;\n    font-weight: 500;\n    color: #6C737D;\n    text-transform: capitalize;\n    margin: 0;\n}\n.vi-dashboard .countdata .countdata-content ul li p span{\n    display: flex;\n    align-items: center;\n    margin-right: .25rem;\n}\n.vi-dashboard .countdata .countdata-content ul li p span i{\n    font-size: 18px;\n    margin-right: .25rem;\n}\n.vi-dashboard .countdata .countdata-content ul li p .txtgreen{\n    color: #08A975;\n}\n.vi-dashboard .countdata .countdata-content ul li p .txtred{\n    color: #EB6262;\n}\n.vi-dashboard .countdata .countdata-chart{\n    width: 100px;\n    height: 100px;\n    display: flex;\n    justify-content: center;\n}\n\n.chart-title{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.chart-title h4{\n    position: relative;\n    font-size: 20px;\n    font-weight: 600;\n    color:var(--dark);\n    padding-left: 1rem;\n    margin: 0;\n}\n.chart-title h4::before{\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 3px;\n    height: 20px;\n    background-color: var(--primary);\n}\n.chart-title p{\n    font-size: 14px;\n    font-weight: 400;\n    color: var(--gray);\n    margin-top: .15rem;\n    margin-bottom: 0;\n}\n.chart-title .chartfilter{\n    display: flex;\n    align-items: center;\n}\n.apexcharts-tooltip{\n    background-color: #fff !important;\n    border: 1px solid #DFEDFC !important;\n    border-radius: 10px !important;\n}\n.apexcharts-text{\n    font-weight: 500 !important;\n}\n.apexcharts-legend{\n    padding: 0 !important;\n}\n.tooltipbox h6{\n    font-size: 12px;\n    font-weight: 500;\n    margin: 0;\n    padding: 5px 10px;\n    background-color: #EBF5FF;\n    color: #24272C;\n    border-bottom: 1px solid #DFEDFC;\n}\n.tooltipbox .tooltipbody{\n    padding: 5px 10px;\n}\n.tooltipbox .tooltipbody p{\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 500;\n    color: #6C737D;\n    margin: 0;\n}\n.tooltipbox .tooltipbody p .legend{\n    display: flex;\n    width: 10px;\n    height: 10px;\n    border-radius: 50px;\n    background-color: var(--border);\n    margin-right: 8px;\n}\n.tooltipbox .tooltipbody p .tooltiptext{\n    color: #24272C;\n}\n\n\n.chartfilter .chartlegend{\n    display: flex;\n    align-items: center;\n}\n.chartfilter .chartlegend p{\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--gray);\n    margin: 0;\n    padding-left: 1rem;\n}\n.chartfilter .chartlegend p span{\n    display: flex;\n    width: 10px;\n    height: 10px;\n    border-radius: 50px;\n    background-color: var(--border);\n    margin-right: 8px;\n}\n.chartfilter .form-control, .chartfilter .form-select, .chartfilter .rs-picker-default .rs-picker-toggle{\n    border-color: var(--border);\n    min-height: 36px;\n}\n.chartfilter .rs-picker-default .rs-picker-toggle.rs-btn{\n    padding-top: 7px;\n    padding-bottom: 7px;\n    min-height: 36px;\n}\n.chartfilter .rs-picker-default:not(.rs-picker-disabled) .rs-btn:hover,\n.chartfilter .rs-picker-default:not(.rs-picker-disabled) .rs-btn:focus {\n    border-color: var(--border);\n}\n.chartfilter .rs-picker-default .rs-picker-toggle.rs-btn .rs-picker-toggle-caret{\n    top: 7px;\n}\n/* ==================================================\n    25. Challan View\n================================================== */\n.echallan-view{\n    border: 1px solid var(--border);\n    padding: 1.5rem;\n    border-radius: .625rem;\n}\n.echallan-view .echallan-view-header{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--border);\n    padding-bottom: 1rem;\n}\n.echallan-view .echallan-view-header p{\n    margin: 0;\n    font-weight: 600;\n}\n.echallan-view .echallan-view-header .echallan-view-header-l{\n    display: flex;\n    align-items: center;\n}\n.echallan-view .echallan-view-header .echallan-view-header-l p{\n    position: relative;\n    margin: 0;\n    padding-left: 10px;\n    padding-right: 10px;\n    font-size: 18px;\n}\n.echallan-view .echallan-view-header .echallan-view-header-l p::before{\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    width: 2px;\n    height: 26px;\n    background-color: var(--border);\n}\n.echallan-view .echallan-view-header .echallan-view-header-l span{\n    color: var(--gray);\n}\n.echallan-view .echallan-view-header .echallan-view-header-l h6{\n    margin: 0;\n    padding-left: 6px;\n}\n.echallan-view.unpaid{\n    border-color: rgba(235, 98, 98, 0.2);\n}\n.echallan-view.unpaid .echallan-view-header{\n    border-bottom-color: rgba(235, 98, 98, 0.2);\n}\n.echallan-view.unpaid .echallan-view-header p{\n    color: #EB6262;\n}\n.echallan-view.unpaid .echallan-view-header .echallan-view-header-l p::before{\n    background-color: #EB6262;\n}\n.echallan-view.unpaid .red{\n    color: #EB6262;\n}\n.echallan-view.paid{\n    border-color: rgba(8, 169, 117, 0.2);\n}\n.echallan-view.paid .echallan-view-header{\n    border-bottom-color: rgba(8, 169, 117, 0.2);\n}\n.echallan-view.paid .echallan-view-header p{\n    color: #08A975;\n}\n.echallan-view.paid .echallan-view-header .echallan-view-header-l p::before{\n    background-color: #08A975;\n}\n.echallan-view.paid .green{\n    color: #08A975;\n}\n.echallan-view .echallan-view-body{\n    padding-top: 1.5rem;\n}\n.echallan-view .echallan-view-body p{\n    color: var(--gray);\n    margin: 0;\n}\n.echallan-view .echallan-view-body span{\n    color: var(--dark);\n    font-weight: 600;\n}\n/* ==================================================\n    25. Code Editor\n================================================== */\n.cm-editor{\n    border: 1px solid var(--border);\n    border-radius: .5rem;\n    overflow: hidden;\n}\niframe#webpack-dev-server-client-overlay {\n    display: none !important\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
